

import Button from "@shared/components/button";
import analysisCard from "@shared/saas-components/ToolsCard.vue";
import Input from "@shared/input";
import Table from "@shared/components/table";
import Loader from "@shared/loader";
import nLoader from "@shared/components/n-loader";
import Pagination from "@shared/saas-components/pagination/index";
import VueMultiselect from "@shared/saas-components/vue-multiselect/index";
// import "vue-multiselect/dist/vue-multiselect.min.css";
import mainAxios from "@/axios";
import osintAxios from "@shared/light-ray/axios/osint-axios";
import {map, extend, isEmpty, startCase, toLower, get, uniqBy, uniq, cloneDeep} from "lodash";
import {setUsernamesDropdownData, getJurisdictionName, getCountryName, csvFileName, convertToCSV} from "@shared/utils/functions";
import modalCompanyDetails from "@shared/saas-components/modal-company-details";
import {mapGetters, mapMutations, mapActions} from "vuex";
import blackAxios from "@/axios";
import JsonCSV from "vue-json-csv";
import NeoCorporateRecordsSidePanel from "@shared/saas-components/corporate-records-sidepanel";
import NeoCorporateRecordsMore from "@shared/saas-components/corporate-records-more";
import { CORPORATE_TOOL_MAPPING, ErrorMessages } from "@shared/utils/constants";
import {EventBus} from "@/main.js";
import neoSwitch from "@shared/components/toggle-switch";
import {DateTime} from "luxon";
import toolsHelper from "@shared/tools/mixins/toolsHelper";
import runAllQueries from "@shared/tools/mixins/runAllQueries";
import PermissionsMixin from "@shared/tools/mixins/permissions";
import tabsTools from "@shared/light-ray/pages/entity-details/tabs.vue"
import { companyIdentifierTabs } from "@shared/tools/utils/toolsTabs.js"
import AllTabs from "@shared/light-ray/assets/svg/entity-details/all_tabs.svg";
import {monitoringSearchData, monitoringHistoryData, getMarkAllAsDone} from "@shared/utils/monitoringTools.js";
import MonitoringFilter from "@shared/saas-components/monitoring-filter";
import DatePicker from "vue2-datepicker";
import loader from "@shared/components/neo-layout/loader";
import { getIconsData } from "@shared/light-ray/services";
import { checkPermission } from "@shared/utils/functions";
import { resolveResponseTotalCount } from "@shared/tools/utils/helpers";
import CheckToolPagination from "@shared/tools/components/check-tool-pagination.vue";


import {
    CORPORATE_RECORDS_CHECK_ID,
    DNB_CHECK_ID,
  } from "@shared/utils/constants";

export default {
    name: "company-identifier",
    components: {
        DatePicker,
        "neo-input": Input,
        "neo-button": Button,
        "neo-table": Table,
        "neo-pagination": Pagination,
        "neo-loader": Loader,
        analysisCard,
        VueMultiselect,
        "n-loader": nLoader,
        "download-csv": JsonCSV,
        "modal-company-details": modalCompanyDetails,
        NeoCorporateRecordsSidePanel,
        NeoCorporateRecordsMore,
        neoSwitch,
        tabsTools, 
        AllTabs,
        MonitoringFilter,
        loader,
        CheckToolPagination
    },
    mixins: [toolsHelper, runAllQueries, PermissionsMixin],
    provide () {
      return {
        isCaseCreated: this.isCaseCreated
      }
    },
    props: {
        mainEntity: {
            type: Array,
            default: () => [],
        },
        toolData: {
            type: Array,
            default: () => [],
        },
        tool: {
            type: String,
            default: "",
        },
        searchQueries: {
            type: Array,
            default: () => [],
        },
        isQueryPanelExpanded: {
            type: Boolean,
            default: false,
        },
        toolSearchQueries: Array,
        monitoring: {
            type: Boolean,
            default: false,
        },
        frequency: {
            default: "",
        },
        /**
         * @typedef {Object} AutorunConfig
         * @property {Object} headers
         * @property {Object} params
         */
        /**
         * @type {AutorunConfig} autorun configurations
         */
        autorun: {
            type: Object,
            default: null,
        },
        title: {
            type: String,
            default: "Corporate Records Search",
        },
        checkId: {
            type: String,
            default: "",
        },
        entityId: {
            type: String,
            default: "",
        },
        entityTypeId: {
            type: String,
            default: "",
        },
        isCaseCreated: {
            type: Boolean,
            default: false,
        },
        listDisabled: {
            type: Boolean,
            default: false,
        },
        prebuiltQuery: {
            type: Object,
            default: null,
        },
        sourceId: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            loadingAllData: true,
            filterJurisdiction: null,
            isLoading: false,
            BVDDateOfBirth: {
                label: "DOB",
                value: null,
                class: "custom-cols-4",
                isSourceSpecific: true,
                drops: [
                  {
                    value: null,
                    props: {
                      placeholder: "YYYY",
                      searchable: true,
                      checkboxes: false,
                      closeOnSelect: true,
                      showLabels: false,
                      maxHeight: 250,
                      tagPlaceholder: "",
                      options: [],
                    },
                  },
                  {
                    value: null,
                    props: {
                      placeholder: "MM",
                      searchable: true,
                      checkboxes: false,
                      closeOnSelect: true,
                      showLabels: false,
                      maxHeight: 250,
                      tagPlaceholder: "",
                      options: [],
                    },
                  },
                  {
                    value: null,
                    props: {
                      placeholder: "DD",
                      searchable: true,
                      checkboxes: false,
                      closeOnSelect: true,
                      showLabels: false,
                      maxHeight: 250,
                      tagPlaceholder: "",
                      options: [],
                    },
                  },
                ],
            },
            monthOptions: [],
            dayOptions: [],
            yearOfBirthOptions: [],
            selectedCountryFilter: null,
            selectedNationalityFilter: null,
            selectedJurisdictionFilter: null,
            countriesOptions: [],
            allFilters: [],
            companyTypeFilter: null,
            sourceTypeFilter: null,
            statusFilter: null, 
            showFiltersPanel: false,
            dateFilters: {
                minDate: 0,
                maxDate: 0,
                data: [],
            },
            monitoringActive: false,
            riskCategoriesOptions: [],
            currentEntity: "",
            typehead: false,
            cardStatusResults: [],
            cardDetailsMap: {},
            totalCount: 0,
            tabsStatus: companyIdentifierTabs.tabsModel,
            dnbCheck: false,
            case_id: "",
            queries: [],
            isAllRunQueries: false,
            page_number: 1,
            items_count: 10,
            fieldType: {
                text: "Company",
                value: "company",
            },
            searchMode: {
                label: "Search Mode",
                value: {
                    name: "Exact Match",
                    value: "keyword",
                },
                props: {
                    options: [
                        {
                            name: "Exact Match",
                            value: "keyword",
                        },
                        {
                            name: "Part Match",
                            value: "relevance",
                        },
                    ],
                    // maxHeight: 250,
                    placeholder: "Select Search Mode",
                    tagPlaceholder: "",
                    closeOnSelect: true,
                    showLabels: false,
                    allowEmpty: false,
                    checkboxes: true,
                    trackBy: "value",
                    label: "name",
                },
                //sisSourceSpecific: true,
            },
            officer: "",
            address: "",
            registry: {
                firstName: "",
                middleName: "",
                lastName: "",
                nickname: "",
            },
            domainCompanyDetails: {},
            companyDetails: null,
            loaderController: {
                companySearch: {
                    loading: false,
                    success: false,
                    filterLoading: false,
                    filterSuccess: false,
                },
            },
            alertMessage: {
                success: null,
                error: null,
            },
            searchKeyword: "",
            selectedItem: null,
            allUsers: [],
            csvData: {
                company: [],
            },
            csvFields: [],
            modalCompanyDetailsData: null,
            jurisdiction: null,
            jurisdictionList: [],
            status: null,
            companyType: null,
            showResult: false,
            triggerRoute: true,
            tabName: "",
            totalResults: 0,
            totalOpenCorporateResults: 0,
            penCorporateResults: 0,
            sourcesCall: null,
            openCorporatesCheck: false,
            clarifiedByCheck: false,
            companyWatchCheck: false,
            bvdCheck: false,
            showSearch: true,
            showMoreInfo: false,
            modalCompanyDetailsDataMore: [],
            newEntity: null,
            entityCount: 1,
            selectedCard: null,
            sourceType: null,
            jurisdictionType: null,
            searchQuery: "",
            currentQuery: -1,
            selectVal: [""],
            searchClicked: false,
            sources: [],
            bulkMonitor: false,
            isSavedLoading: {
                loading: false,
                loadingCardIndex: null,
            },
            request_id: null,
            monitoringStatus: false,
            isloadingDetails: false,
            isBulkMonntoringLoading: false,
            timeline: [],
            isOldVersionSelected: false,
            latestVersionResultsCount: 0,
            apiCallPages: 1,
            isComparisonModeOn: false,
            nerFilters: false,
            getReadOnlyMode: false,
            cardStatusCounts: {
                all:0,
                confirmedCount: 0,
                unknownCount: 0,
                potentialCount: 0,
                irrelevantCount: 0
            },
            dateRange: [],
            dataTypeOp: [
                {label: "All Results", tLabel: "components.tools.lexis_bridger.all_results", value: "All"},
                {label: "Unacknowledged Results", tLabel: "components.tools.lexis_bridger.unacknowledged_results", value: "New"},
                {label: "Acknowledged Results", tLabel: "components.tools.lexis_bridger.acknowledged_results", value: "Done"},
            ],
            selectedDataType: {label: "All Results", value: "All"},
            appliedFilterCount: 0,
            dbaddress: "",
            locality: "",
            postCode: "",
            phone: "",
            registrationNumber: "",
            duns: "",
            region: "",
            email: "",
            fetchMoreDetails: {},
            dbJurisdiction: null,
            licenseLevels: {},
            dbJurisdictionList: [],
            selectedJurisdiction: false,
            isAdvancedSearch: false,
            perPageOptions: [10, 25, 50, 100],
            open:false,
            order_by: null,
        };
    },
    computed: {
        ...mapGetters([
            "getNoMatchesFlag",
            "getSelectedEntity",
            "getResearchData",
            "getSelectedToolQuery",
            "getNeoCaseId", 
            "getProduct", 
            "getAllToolsData",
            "getAllMonitoringData", 
            "getCaseCompanies", 
            "getCasePersonalData", 
            "searchedQueries", 
            "getPermissions", 
            "checkPermissionsFetched", 
            "getMonitoringDateFilter", 
            "getAllToolNames",
            "getUserFeatures",
            "getDomainCompanyDetailsSearchList",
            "getCheckDescription",
            // "getAutoPopulatedCountryList",
        ]),
        fieldEntityType: {
            get() {
                return this.fieldTypeOptions[0].categories.find(x => x.value == this.fieldType.value);
            }, 
            set(val) {
                this.fieldType = val;
            }
        },
        dropOptionsGroupTranslation() {
            return {
                source: this.$t('components.saas.source'),
                countries: this.$t('components.saas.countries'),
                jurisdiction: this.$t('components.saas.jurisdiction')
            }
        },
        sortOptions() {
            if (this.order_by?.value == "timestamp") {
                {
                    return [
                        {
                            name: "Card Date",
                            label: "Card Date",
                            value: "timestamp"
                        },
                        
                    ];
                }
            }
            return [
                {
                    name: "Card Date",
                    label: "Card Date",
                    value: "timestamp"
                }
            ];
        },
        dataTypeOpList() {
            return this.dataTypeOp.map(i=>({
                ...i, 
                tLabel: this.$t(i.tLabel)
            }))
        }, 
        fieldTypeOptions() {
            return [
                {
                    group: this.$t('components.tools.company_identifier.field_type'),
                    categories: [
                        {
                            text: this.$t('components.tools.company_identifier.company'),
                            value: "company",
                        },
                        {
                            text: this.$t('components.tools.company_identifier.officer'),
                            value: "officer",
                        },
                        
                    ],
                },
            ]
        },
        domainCompanyDetailsSearch: {
            get() {
                return this.getDomainCompanyDetailsSearchList;
            },
            set(val) {
                this.SET_DOMAIN_COMPANY_DETAILS_SEARCH_LIST(val);
            },
        },

        tabsStatusList() {
            return this.tabsStatus.list.map(i=>({
                ...i,
                label: this.$t(`components.light_ray.${i.label}`?.toLowerCase())
            }))
        }, 

        getHiddenTabs() {
            // return this.isCaseCreated ? [] : companyIdentifierTabs.hiddenTabs
            return [];
        },

        getTimelineData() {
            return this.timeline
        },
        monitoringAllowed() {
            return this.getUserFeatures.includes("corporate_record__monitoring")
        },

        formattedDate() {
            let formatDate = [];
            if (this.dateRange?.length) {
                let start = this.dateRange[0];
                start = DateTime.fromMillis(start);
                start = start.toFormat("dd/MM/yyyy");
                let end = this.dateRange[1];
                end = DateTime.fromMillis(end);
                end = end.toFormat("dd/MM/yyyy");
                formatDate = [start, end];
            }
            return formatDate;  
        },
        getHeight() {
            let card = document.getElementById("case-list")?.scrollHeight;
            let tabs = document.getElementById("dashboard-tabs")?.scrollHeight || 0;
            let header = document.getElementById("disclaimer")?.offsetHeight || 0;
            if (header && card) {
                return `height:${card - (tabs + header)}px`;
            } else {
                return `height: 100%`  
            }
            // else return `height: calc(100vh-52vh)`;
        },
        isToolActive() {
            let toolActive = this.getAllToolNames?.children?.find((el) => {
                if (el.activeProcess === "company-name") {
                    return el;
                }
            });
            if (toolActive) {
                return toolActive.active;
            } else return true;
            // return false;
        },

        searchQueryExists() {
            if (this.autorun) return true;
            
            if (!this.toolSearchQueries?.length) return false

            let flag = true;
            if (this.toolSearchQueries.findIndex((el) => el._id === this.getSelectedToolQuery?.query_id) < 0) flag = false;
            return flag;
        },

        fetchAllData() {
            if (this.getResearchData.personalDetails?.length || this.getResearchData.socialProfiles?.length) {
                this.getToolData();
            }
        },

        isMoreOpenCorporate() {
            let totalOpenCorporatePages = parseInt(this.totalOpenCorporateResults / 10, 10);
            if (this.totalOpenCorporateResults % 10) totalOpenCorporatePages += 1;

            let totalPages = parseInt(this.totalResults / 10, 10);
            if (this.totalResults % 10) totalPages += 1;

            if (totalPages < totalOpenCorporatePages) return true;
            else return false;
        },

        isCompanyEntity() {
            let flag = false;
            if (this.fieldType.value === "company") {
                flag = true;
            } else {
                for (let i = 0; i < this.queries.length; i++) {
                    if (this.queries[i].type.value === "company") {
                        flag = true;
                        break;
                    }
                }
            }
            return flag;
        },

        isPersonEntity() {
            let flag = false;
            if (this.fieldType.value === "officer") {
                flag = true;
            } else {
                for (let i = 0; i < this.queries.length; i++) {
                    if (this.queries[i].type.value === "officer") {
                        flag = true;
                        break;
                    }
                }
            }
            return flag;
        },

        query() {
            let query = "";
            if (this.searchKeyword || this.officer || this.address) query = this.searchKeyword || this.officer || this.address;
            else if (this.registry) {
                let result = [];
                result.push(this.registry?.firstName);
                result.push(this.registry?.middleName);
                result.push(this.registry?.lastName);
                query = result.join(" ");
            }
            return query;
        },

        getStatusList() {
            let data = [];
            if (this.fieldType.value === "officer") {
                let openCorporatesResults = this.domainCompanyDetailsSearch?.filter((company) => company?.key === "officer");
                if (this.openCorporatesCheck && openCorporatesResults?.length) {
                    // data = ["Active"];
                    let flag = false;
                    this.domainCompanyDetailsSearch?.forEach((company) => {
                        if (company?.inactive && company.key === "officer" && !flag) {
                            flag = true;
                        } else if (!data.includes("Active") && !data.includes("Inactive")) {
                            if (company?.api_all_data?.officer?.inactive === true) data.push("Inactive");
                            else if (company?.api_all_data?.officer?.inactive === false) data.push("Active");
                        }
                        return;
                    });
                    if (flag && !data.includes("Inactive")) data.push("Inactive");
                }
                if (this.clarifiedByCheck) {
                    this.domainCompanyDetailsSearch?.forEach((company) => {
                        if (!data.includes(company?.status) && company.key === "officer_clarifiedBy") {
                            if (company?.status) data.push(company?.status);
                        }
                    });
                }
            } else if (this.fieldType.value !== "officer") {
                this.domainCompanyDetailsSearch?.forEach((company) => {
                    if (!data.includes(company?.status)) {
                        if (company?.status) data.push(company?.status);
                        else data.push("Not available");
                    }
                    if (!data.includes("Active")) {
                        if (company?.api_all_data?.company?.inactive === false) data.push("Active");
                    }
                    if (!data.includes("Inactive")) {
                        if (company?.api_all_data?.company?.inactive === true) data.push("Inactive");
                    }
                });
            }
            return [{group: this.$t('components.saas.status'), categories: uniq(data)}];
        },

        getCompanyTypeList() {
            let data = [];
            this.domainCompanyDetailsSearch?.forEach((company) => {
                if (!data.includes(company?.company_type)) {
                    if (company?.company_type) data.push(company?.company_type.toLowerCase());
                    else data.push("Not available");
                }
            });
            return [{group: this.$t('components.saas.company_type'), categories: uniq(data)}];
        },

        getSourcesList() {
            let data = [];
            this.domainCompanyDetailsSearch?.forEach((company) => {
                if (!data.includes(company?.key) && this.fieldType.value !== "officer") {
                    if (company?.key) {
                        if (company.key !== "db") data.push(company?.key);
                        else {
                            if (this.dbCorpRecord && !this.dbResellerCorpRecord) data.push("d&b");
                            else data.push(company?.key);
                        }
                    } else data.push("Not available");
                } else if (!data.includes(company?.sourceTag) && this.fieldType.value === "officer") {
                    if (company?.sourceTag) data.push(company?.sourceTag);
                    else data.push("Not available");
                }
            });
            return [{group: this.$t('components.saas.source'), categories: uniq(data)}];
        },

        getJurisdictionList() {
            let data = [];
            this.domainCompanyDetailsSearch?.forEach((company) => {
                let jurisdiction = company?.jurisdiction || company?.api_all_data?.officer?.jurisdiction_code;
                if (jurisdiction && !data.includes(jurisdiction.toLowerCase()))
                    data.push({
                        value: jurisdiction.toLowerCase() === "uk" ? "gb" : jurisdiction.toLowerCase(),
                        label:getJurisdictionName(jurisdiction),
                    });
            });
            data = data.filter((e) => e.label);
            return [{group: this.$t('components.saas.jurisdiction'), categories: uniqBy(data, "label")}];
        },

        // hasMorePages() {
        //     if (this.page_number * this.items_count > this.domainCompanyDetailsSearchList.length) return false;
        //     return true;
        // },
        getTotalPages() {
            this.domainCompanyDetailsSearchList = this.domainCompanyDetailsSearchList
                .filter(item => item.api_all_data?.doc_id) // Remove entries with no doc_id
                .filter((item, index, self) =>
                    index === self.findIndex(t => t.api_all_data.doc_id === item.api_all_data.doc_id)
                );
            return Math.ceil(this.domainCompanyDetailsSearchList?.length / this.items_count);
        },

        domainCompanyDetailsSearchList() {
            if (this.fieldType.value === "company" || this.fieldType.value === "officer" || this.fieldType.value === "address" || this.isAllRunQueries) {
                let data = this.domainCompanyDetailsSearch?.filter((ele) => ele?.company_name?.toLowerCase().includes(this.searchQuery.toLowerCase()));
                if (this.companyType) {
                    data = data.filter((company) => company?.company_type === this.companyType || company?.company_type.toLowerCase() === this.companyType || (this.companyType === "Not available" && !company.company_type));
                }
                if (this.status) {
                    if (this.fieldType.value === "officer") {
                        if (this.status === "Inactive") data = data.filter((company) => (company?.key === "officer" && company?.inactive) || (company?.key === "officer" && company?.api_all_data?.officer?.inactive) || (company?.key !== "officer" && this.status === company.status));
                        else if (this.status === "Active") data = data.filter((company) => (company?.key === "officer" && !company.inactive) || (company?.key === "officer" && !company?.api_all_data.officer?.inactive) || (company?.key !== "officer" && this.status === company.status));
                        else data = data.filter((company) => this.status === company.status);
                    } else if (this.fieldType.value !== "officer") data = data.filter((company) => company?.status === this.status || (this.status === "Not available" && !company.status) || (company?.api_all_data?.company?.inactive && this.status === "Inactive") || (!company?.api_all_data?.company?.inactive && company?.api_all_data?.company?.inactive != null && this.status === "Active"));
                }
                if (this.sourceType && this.sourceType !== "d&b") {
                    data = data.filter((company) => company?.key === this.sourceType || company?.sourceTag === this.sourceType || (this.sourceType === "Not available" && !company.key));
                } else if (this.sourceType && this.sourceType === "d&b") {
                    data = data.filter((company) => company?.key === "db" || company?.sourceTag === this.sourceType || (this.sourceType === "Not available" && !company.key));
                }
              
                if (this.jurisdictionType) {
                    data = data.filter((company) => {
                        let jurisdiction = company?.jurisdiction || company?.api_all_data?.officer?.jurisdiction_code;
                        if (jurisdiction?.toLowerCase() === "uk") {
                            return getCountryName("gb") == getCountryName(this.jurisdictionType.value?.toLowerCase()); // Change uk jurisdiction code to gb
                        } else {
                            return getCountryName(jurisdiction?.toLowerCase()) == getCountryName(this.jurisdictionType.value?.toLowerCase());
                        }
                    });
                }
                // sort data according to match score  in descending order (highest score first),
                if(data && data.length) {
                    data = this.order_by?.value? data : data.sort((a,b) => {
                        const scoreA = a.api_all_data?.Match ?  a.api_all_data.Match[0]?.SCORE  :  -Infinity
                        const scoreB = b.api_all_data?.Match ?  b.api_all_data.Match[0]?.SCORE  :  -Infinity
                        return scoreB - scoreA; 
                    })
                }

                const total_pages = Math.ceil(data?.length / this.items_count) || 1;
                if (this.page_number > total_pages)
                    this.page_number = total_pages;
                return data;
            }
        },

        allUsersList() {
            return [{group: this.$t('components.tools.company_identifier.company_name'), categories: this.allUsers}];
        },
        searchedQueryKeyword() {
            if (this.fieldType.value === "company") {
                return this.searchKeyword;
            }
            if (this.fieldType.value === "officer") {
                return this.officer;
            }
            if (this.fieldType.value === "address") {
                return this.address;
            }
            if (this.fieldType.value === "registry") {
                return Object.values(this.registry)
                    .map((ele) => ele)
                    .join(" ")
                    .replace(new RegExp("\\s{2,}", "gm"), " ");
            }
        },
        selectedQuery() {
            var findData = this.searchedQueries.filter(x => x.tool == "company-name").find((data) => {
                if (this.fieldType.value === "company") {
                    if (data.query?.country)    
                        return data.query.name == this.searchedQueryKeyword
                        && data.query?.country == this.selectedJurisdictionFilter?.value
                    else
                        return data.query.name == this.searchedQueryKeyword
                } else if (this.fieldType.value === "officer") {
                    return data.query?.officer == this.searchedQueryKeyword
                    && data.query?.dobfrom == this.getDob()
                    && data.query?.nationality[0] == this.selectedNationalityFilter?.label
                    && data.query?.countryofresidence[0] == this.selectedCountryFilter?.label
                } else if (this.fieldType.value === "address") {
                    return data.query.address == this.searchedQueryKeyword;
                }
            });
            if (!findData) return null;
            let maskedQuery = this.viewQuery(findData)
            findData.query_payload = {
                query_id: findData?._id,
                query_string: maskedQuery,
                search_string: maskedQuery,
            };
            return findData
        },
        // bvd__corp_record
        bvdSourceAuth() {
            return this.getUserFeatures.includes("bvd__corp_record");
        },
        dbCorpRecord() {
            return this.getUserFeatures.includes("db__corp_record");
        },
        dbResellerCorpRecord() {
            return this.getUserFeatures.includes("dnb_reseller__corp_record");
        },
        openCorpSourceAuth() {
            // if (this.$route.name === "tools") {
            return this.getUserFeatures.includes("open_corporates__corp_record");
            // }
        },
        clarifiedBySourceAuth() {
            // if (this.$route.name === "tools") {
            return false
            // }
        },
        companyWatchSourceAuth() {
            // if (this.$route.name === "tools") {
            return false
            // }
        },
        checkMarkAllDone() {
            // let searchedResultList = [];
            // searchedResultList = this.domainCompanyDetailsSearchList.slice(this.items_count * (this.page_number - 1), this.page_number * this.items_count);
            // if (searchedResultList && searchedResultList.length) return searchedResultList.every((result) => result.api_all_data.changes_viewed);P
            if (this.domainCompanyDetailsSearchList && this.domainCompanyDetailsSearchList.length)
                return this.domainCompanyDetailsSearchList.every((result) => result.api_all_data.changes_viewed);
            else return false;
        },
        checkBulkToggleOn() {
            let searchedResultList = [];
            searchedResultList = this.domainCompanyDetailsSearchList;
            if (searchedResultList && searchedResultList.length) {
                this.isBulkMonitorOn = searchedResultList.every((result) => result.api_all_data.monitoring_status);
                return searchedResultList.every((result) => result.api_all_data.monitoring_status);
            } else return false;
        },

        allSourcesChecked() {
            let allSourcesChecked = false;
            if (this.openCorporatesCheck && this.clarifiedByCheck && this.companyWatchCheck && this.bvdCheck && this.dnbCheck) {
                allSourcesChecked = true;
            }
            return allSourcesChecked;
        },
        isMonitoringTab() {
            return this.$route.name === "monitoring";
        },

        last_run_date() {
            const querySource = this.autorun ? this.selectedQuery : this.getSelectedToolQuery?.query;
            return querySource?.last_runtime;
        },
        prebuiltQueryPayload() {
            return this.prebuiltQuery || {};
        },
        prebuiltOfficerQueryPayload() {
            // optionally, the 'name' prop may be parsed into the "officer" key

            /* eslint-disable-next-line no-unused-vars */
            const { name, ...prebuiltPayload } = this.prebuiltQueryPayload;
            return prebuiltPayload;
        },

        isMonitoringAllowed() {
            return this.getUserFeatures.includes("corporate_record_bvd__monitoring") || 
                this.getUserFeatures.includes("corporate_record_db__monitoring") || 
                this.getUserFeatures.includes("corporate_record_op__monitoring");
        },

        shouldShowSortOptions() {
            const sources = this.getSourcesList?.[0]?.categories || [];
            const onlyDbSources = sources.length === 1 && (sources[0] === "db" || sources[0] === "d&b");
            return !onlyDbSources;
        }
    },
    async created() {
        if (this.autorun) this.isLoading = true;
        EventBus.$on("handleDone", (data) => {
            let allResults = cloneDeep(this.domainCompanyDetailsSearch);
            if (!data.oldVersion) {
                let cardIndex = allResults?.findIndex((res) => res?.api_all_data?.doc_id === data?.card?.api_all_data?.doc_id);
                let cardResult = allResults[cardIndex];
                allResults.splice(cardIndex, 1, cardResult);
                this.domainCompanyDetailsSearch = allResults;
            } else {
                let oldVersionResults = cloneDeep(this.timeline);
                let index = oldVersionResults.findIndex((el) => el.curr_index === data.curr_index);
                if (index > -1) {
                    oldVersionResults[index] = data.card;
                    this.timeline = oldVersionResults;
                    // this.checkMarkAllDone()
                }
            }
            this.$forceUpdate();
        });

        EventBus.$on("handleResultCorporateSave", (data) => {
            // API Call to save card
            this.handleSavedCard(data);
        });

        EventBus.$on("handleMonitoring", (data) => {
            let allResults = cloneDeep(this.domainCompanyDetailsSearch);
            let cardIndex = data.index
            // TO DO
            // Card index is bit different in domainCompanyDetailsSearch with selected one
            // right now using the selected card index which we are passing in data params
            // let cardIndex = allResults?.findIndex((res) => res?.api_all_data?.doc_id === data?.card?.api_all_data?.doc_id);
            if (cardIndex > -1) {
                let cardResult = allResults[cardIndex];
                allResults.splice(cardIndex, 1, cardResult);
                this.domainCompanyDetailsSearch = allResults;
            }
            // let result = cloneDeep(this.domainCompanyDetailsSearch);
            // result[data.index] = data.card
            // this.domainCompanyDetailsSearch = result;
            this.$forceUpdate();
        });
     
        EventBus.$on("showMoreData", (data) => {
            this.showMoreData(data);
        });
        EventBus.$on("fetchReport", (data) => {
            this.fetchReport(data);
        });
        EventBus.$on("handleExpandAllPanel", (data) => {
            this.handleExpandAllPanel(data);
        });
    },
    async mounted() {
        this.SET_QUERIES_LOADER(true)
        if (this.monitoringAllowed) {
            await this.setMonitoring()
        }
        else {
            this.setMonitoring(true)
        }
        this.setDefaultFilters()
        await this.getRiskCategoriesOptions()
        this.$emit("updateQueryTotal", { checkName: this.$route.query.check_name })
        this.$emit("getQueriesMonitoring")
        await this.getJurisdiction();
        await this.getDnbJurisdiction();
        // await this.updateMonitoringCount()
        
        if (!this.$store.getters?.getIconsData.length) {
            const iconsdata = await getIconsData();
            this.$store.commit("SET_ICONS_DATA", iconsdata?.data.icons_data ?? []);
        }

        this.currentEntity = this.$route.query.entityId;

        this.monitoringActive = false
        this.showResult = false
        this.showSearch = true
        // this.triggerRoute = false;
        this.clarifiedByCheck = false
        this.companyWatchCheck = false
        this.bvdCheck = false
        this.dnbCheck =false
        this.openCorporatesCheck = false;
        this.selectVal = []
        if (this.getSelectedEntity?.entity_type == 'Company') {
            let preFilledValue = this.prebuiltQueryPayload?.name
                || this.getSelectedEntity?.entity_name

            this.selectedItem = {
                text: "Company",
                value: preFilledValue
            }  
            
            this.fieldType = {
                text: "Company",
                value:"company"
            }
            this.officer = null
            this.searchKeyword = preFilledValue
        } else if  (this.getSelectedEntity?.entity_type == 'Person') {
            this.fieldType = {
                text: "Officer",
                value:"officer"
            }
            this.officer = this.prebuiltQueryPayload?.name
                || this.getSelectedEntity?.entity_full_name
            this.searchKeyword = null
        }
        await this.getToolData();
        await this.getToolsStatus();
        await this.getCountriesList();
        await this.fillYears();
        await this.setAutoPopulateValue();
        if (this.autorun) {
            await this.autoInit();
        } else if (this.toolSearchQueries?.length) {
            this.$emit("selectAllQueries");
        }

        this.SET_QUERIES_LOADER(false)
        this.loadingAllData = false
        await this.getSavedQueryList();
    },
    watch: {
        // "$route.query"() {
        //     if (this.triggerRoute) {
        //         this.redirectToQuery();
        //         this.currentQuery = -1;
        //     }
        // },
        // officer() {
        //     this.showResult = false;
        //     this.showSearch = true;
        // },

        // address() {
        //     this.showResult = false;
        //     this.showSearch = true;
        // },

        // selectedItem: {
        //     handler(val) {
        //         this.showResult = false;
        //         this.showSearch = true;
        //     },
        //     deep: true,
        // },

        // registry: {
        //     handler: function() {
        //         this.showResult = false;
        //         this.showSearch = true;
        //     },
        //     deep: true,
        // },
       
    },
    beforeDestroy() {
        // ! currently, we can't use cached data
        // TODO consider all cases when data must be reset to use this:
        // this.setToolsData("company-name"); // commented to not load memory

        this.SET_DOMAIN_COMPANY_DETAILS_SEARCH_LIST([]);

        EventBus.$off("handleDone");
        EventBus.$off("handleResultCorporateSave");
        EventBus.$off("handleExpandAllPanel");
        EventBus.$off("fetchReport");
        EventBus.$off("showMoreData");
    },
    methods: {
        ...mapMutations([
            "SET_ALL_TOOLS_DATA",
            "SET_ALL_MONITORING_DATA",
            "SET_TOOLS_DATA",
            "SET_QUERIES_LOADER",
            "SET_DOMAIN_COMPANY_DETAILS_SEARCH_LIST",
        ]),
        checkPermission,

        async getQueryPayload(requestBody, source) {
            if (!this.autorun) return requestBody;
            
            const { data } = await mainAxios.post("/tenant-check/search-query", {
                "query": requestBody,
                "entity_type_id": this.entityTypeId,
                "source": source
            });
            return data?.query || requestBody;
        },

        async afterSearchResponseReceived({ searchResults = [] }) {
            const { case_id, id } = this.getSelectedEntity;

            try {
                await this.refreshCheckToolSelfStatus({
                    caseId: case_id,
                    entityId: id,
                    checkId: this.resolvedCheckId,
                    searchResults,
                    options: {
                        refreshCheckStatus: this.autorun ? true : false
                    }
                });
            } catch {
                console.error('error::afterSearchResponseReceived')
            }
        }, 
        async fetchMoreData(details) {
            let payload = {
                doc_id: details.api_all_data.doc_id,
                request_id: details.api_all_data.query_id,
            };
            let response = await osintAxios.post("/api/v1/db/meta-deta/fetch-more-data", payload);
            this.fetchMoreDetails = response.data.data[0];
        },
        jurisdictionSelection() {
            if (this.dbJurisdiction !== null) {
                this.selectedJurisdiction = false;
            }
        },
        async onSelectOption(option) {
            this.order_by = this.order_by?.value === option.value ? null : option;
            let sort = {
                sort_by: this.order_by?.value || "",
                sort_order: this.order_by?.value ? "desc" : ""
            }
            if(this.isAllRunQueries) {
                this.domainCompanyDetailsSearch = [];
                this.offsetPag = 0;
                this.limitPag = 1;
                this.isNextPag = true;
                this.resetPage();
                await this.onRunAllQueries(null, "domainCompanyDetailsSearch",sort);
                if((this.page_number + 1) * this.items_count >= this.domainCompanyDetailsSearch?.length && 
                    this.domainCompanyDetailsSearch.length < this.totalRecordsInAllQueries) {
                    await this.onRunAllQueries(null, "domainCompanyDetailsSearch", sort);}
                
            } else {
                // For individual queries, apply tab filtering after sorting
                const currentTab = this.tabsStatus.selected;
                await this.manualSearch(false, true);
                // Reapply tab filtering
                if (currentTab === "all") {
                    this.domainCompanyDetailsSearch = this.cardStatusResults;
                } else if (currentTab === "unknown") {
                    this.domainCompanyDetailsSearch = this.cardStatusResults.filter((res) => !res.card_status || res.card_status?.toLowerCase() === currentTab);
                } else {
                    this.domainCompanyDetailsSearch = this.cardStatusResults.filter((res) => res.card_status && res.card_status.toLowerCase() === currentTab);
                }
                this.domainCompanyDetailsSearch = this.domainCompanyDetailsSearch
                    .filter(item => item.api_all_data?.doc_id)
                    .filter((item, index, self) =>
                        index === self.findIndex(t => t.api_all_data.doc_id === item.api_all_data.doc_id)
                    )
                    .map((ele, index) => ({ ...ele, current_index: index }));
                this.setCardStatusCounts();
            }
            this.open = false;
        },
        advancedSearch() {
            if (!this.isAdvancedSearch) {
                this.registrationNumber = "";
                this.dbaddress = "";
                this.postCode = "";
                this.locality = "";
                this.region = "";
                this.phone = "";
                this.duns = "";
                this.selectedJurisdiction = false;
                this.email = "";
            }
        },
        ...mapActions(["getAnalysisDropdownData", "getAllCaseCompanies", "getToolsStatus", "refreshCheckToolSelfStatus", "setQueryResultLoader"]),
        async dnbLicenseLevel() {
            let response = await osintAxios.get("/api/v1/db/meta-deta/license");
            if (response.data && response.data.data) this.licenseLevels = response.data.data;
            else if (response.data && response.data.status_code === 2000) this.$toast.error(response.data.message);
        },
        async getDnbJurisdiction() {
            let url = "/service/db/jurisdiction_master";

            await mainAxios
                .get(url, {  headers: {"x-wlp-reference": `${process.env.VUE_APP_BACKEND_URL}` , "x-status": 'RUNNING', "x-case-id": this.getNeoCaseId,},
                })
                .then((response) => {
                    if (response && response.data) {
                        this.dbJurisdictionList = [{group: this.dropOptionsGroupTranslation.source, categories: response.data.data.country_details}];
                    }
                })
                .catch((error) => {console.log(error)});
        },
        async updateMonitoringCount() {
            const payload = {
                minDate: this.dateFilters.minDate,
                maxDate: this.dateFilters.maxDate,
                tool: this.$route.query.check_name || this.autorun?.headers['x-tool-name'],
            }
            await this.getQueryMonitoringEvents(payload)
        },
        async getCountriesList() {
            // let countries = [];
            await mainAxios
                .get("/service/search-engine/location", {
                    headers: {
                        "x-wlp-reference": process.env.VUE_APP_BACKEND_URL,
                        "x-status": 'RUNNING',
                        "x-case-id": this.getNeoCaseId,
                    },
                })
                .then((response) => {
                    if (response && response.data) {
                        const country = response.data.data.map((el) => ({
                            label: el.country,
                            value: el.country_code,
                            option: el.country_cr_code,
                        }));
                        this.countriesOptions = [
                            {
                                group: this.dropOptionsGroupTranslation.countries,
                                categories: country,
                            },
                        ];
                        this.$store.dispatch("storeAllCountryList", country);
                    }
                })
                .catch(() => {});
        },
        setAutoPopulateValue(){

            const systemFieldsData = this.$store.getters.getSystemFields;
            // const allCountryList = this.getAutoPopulatedCountryList;
            // DOB
            if(systemFieldsData?.['date_of_birth'] && systemFieldsData?.['date_of_birth'].length) {
                let month =  systemFieldsData['date_of_birth'][0].split("-")[1];
                month = Number(month, 10);
                this.BVDDateOfBirth.drops[0].value = systemFieldsData['date_of_birth'][0].split("-")[0];
                this.BVDDateOfBirth.drops[1].value = this.monthOptions[month-1];
                this.BVDDateOfBirth.drops[2].value = systemFieldsData['date_of_birth'][0].split("-")[2];
            }
            if(systemFieldsData?.company_name?.length) {
                if (systemFieldsData && systemFieldsData.trade_name) {
                    this.setSearchedUser(systemFieldsData?.trade_name[0]);
                } 
            } 
            // if(systemFieldsData['nationality'] && systemFieldsData['nationality'].length) {
            //     const nationality = allCountryList.find((el) => el.name === systemFieldsData['nationality'][0]) || null;
            //      if(nationality) {
            //         this.selectedNationalityFilter = {
            //             label: nationality?.name,
            //             value: nationality?.code,
            //         }
            //      }
            
            // }  
            // if(systemFieldsData['country'] && systemFieldsData['country'].length) {
            //     const country = allCountryList.find((el) => el.name === systemFieldsData['country'][0]) || null;             
            //     if(country) {
            //         this.selectedCountryFilter = {
            //             label: country?.name,
            //             value: country?.code,
            //         }
            //         this.selectedJurisdictionFilter = {
            //             label: country?.name,
            //             value: country?.code,
            //         }
            //     }
            // }   
        },

        getDob() {
            if (
              this.BVDDateOfBirth?.drops &&
              this.BVDDateOfBirth?.drops[0]?.value &&
              this.BVDDateOfBirth?.drops[1]?.value &&
              this.BVDDateOfBirth?.drops[2]?.value
            ) {
              let year = this.BVDDateOfBirth.drops?.[0]?.value?.toString();
              let month = this.BVDDateOfBirth.drops?.[1]?.value
                ? (
                    this.BVDDateOfBirth.drops?.[1]?.props?.options?.findIndex(
                      (idx) => idx === this.BVDDateOfBirth.drops?.[1]?.value
                    ) + 1
                  )
                    ?.toString()
                    .padStart(2, "0")
                : "";
              let date = this.BVDDateOfBirth.drops?.[2]?.value
                ?.toString()
                .padStart(2, "0");
              return year + "-" + month + "-" + date;
            } else {
              return "";
            }
            
        },

        fillYears() {
          try {
            const now = new Date().getUTCFullYear();
            this.dayOptions = Array(31)
              .fill("")
              .map((i, idx) => idx + 1);
            (this.monthOptions = [
              "January",
              "February",
              "March",
              "April",
              "May",
              "June",
              "July",
              "August",
              "September",
              "October",
              "November",
              "December",
            ]),
              (this.yearOfBirthOptions = Array(now - 1899)
                .fill("")
                .map((v, idx) => now - idx));
            // this.yearOfBirth.props.options = this.yearOfBirthOptions;
         
            this.BVDDateOfBirth.drops[2].props.options = this.dayOptions;
            this.BVDDateOfBirth.drops[1].props.options = this.monthOptions;
            this.BVDDateOfBirth.drops[0].props.options = this.yearOfBirthOptions;
          } catch (err) {
            console.log("err", err);
          }
        },
        setDefaultFilters() {
            this.allFilters = []
            this.selectedDataType = {label: "All Results", tLabel: this.$t('components.tools.lexis_bridger.all_results'), value: "All"}
            if (this.monitoringActive) {
                this.allFilters.push({name: 'monitoring', value: this.selectedDataType.label})
                // if (this.formattedDate?.length)
                //     this.allFilters.push({name: 'monitoringDateRange', value: `${this.formattedDate[0]} To ${this.formattedDate[1]}`})
            }
        },
       
        async getRiskCategoriesOptions() {
            try {   
                let headers = { "x-case-id": this.getNeoCaseId }
                const url = '/service/risk-categories'
                let categories = await mainAxios.get(url, {headers});
                this.riskCategoriesOptions = categories.data.risk_data
            } catch (err) {
                console.log(err)
            }
        },

        async filterData() {
            await this.handleApplyFilters();
        },

        async handleApplyFilters() {
            this.allFilters = [];
            this.appliedFilterCount = 0;
            if (this.monitoringActive && !this.isAllRunQueries) {
                await this.search(false, true)
            }
            this.status = this.statusFilter
            this.companyType = this.companyTypeFilter
            this.sourceType = this.sourceTypeFilter
            this.jurisdictionType = this.filterJurisdiction


            let allFilters = ["statusFilter", "companyTypeFilter", "sourceTypeFilter", "filterJurisdiction"];

            this.allFilters = [];
            let that = this;
            for (let filter in allFilters) {
                let filterValues = get(that, allFilters[filter]);
            
                if (filterValues) {
                    this.allFilters.push({
                        name: allFilters[filter],
                        value: allFilters[filter] === 'filterJurisdiction' ? filterValues.label : filterValues,
                    });
                }
            }
            if (this.monitoringActive) {
                this.allFilters.push({name: "monitoring",value:this.selectedDataType.label})
                this.appliedFilterCount = 1;

                if (this.formattedDate?.length) {
                    this.allFilters.push({value:`${this.formattedDate[0]} To ${this.formattedDate[1]}`, name: "monitoringDateRange"})
                    this.appliedFilterCount = 2;
                }
            }

            if (this.searchQuery) this.appliedFilterCount += 1;
            if (this.statusFilter) this.appliedFilterCount += 1;
            if (this.companyTypeFilter) this.appliedFilterCount += 1;
            if (this.sourceTypeFilter) this.appliedFilterCount += 1;
            if (this.filterJurisdiction?.label) this.appliedFilterCount += 1;

            this.setCardStatusCounts()
        },

        async selectedRemoveFilters(filter) {
            // let match = -1;
            switch (filter.name) {
                // case "statusFilter":
                //     match = this[filter.name].findIndex((el) => el === filter.value);
                //     if (match > -1) this[filter.name].splice(match, 1);
                //     break;
                // case "companyTypeFilter":
                //     match = this[filter.name].findIndex((el) => el === filter.value);
                //     if (match > -1) this[filter.name].splice(match, 1);
                //     break;
                // case "sourceTypeFilter":
                //     match = this[filter.name].findIndex((el) => el === filter.value);
                //     if (match > -1) this[filter.name].splice(match, 1);
                //     break;
                // case "filterJurisdiction":
                //     match = this[filter.name].findIndex((el) => el.value === filter.value.value);
                //     if (match > -1) this[filter.name].splice(match, 1);
                //     break;
                case "monitoringActive":
                    this.selectedDataType = {label: "All Results", value: "All"};
                    break;
                case "monitoringDateRange":
                    this.dateRange = [];
                    break;
                default:
                    this[filter.name] = null;
                    break;
            }
            this.handleApplyFilters();
            
        },
        convertToCSV(arr) {
            return convertToCSV(arr);
        },
        csvFileNames(query) {
            return csvFileName('company-name', query, 'companies');
        },
        async getSavedQueryList(){
            try{
                const url = `/case/case-check/${this.$route.query.check_id}/pre-build-query`
                let { data } = await mainAxios.get(url);
                this.$store.commit("SET_SAVED_QUERIES", data);
            }
            catch(error){
                this.$toast.error(error.response.data.detail)
            }
        },
        async handleSaveSearchQueryData(payload){
            try{
                const url = `/case/case-check/${this.$route.query.check_id}/pre-build-query`
                let { data } = await mainAxios.post(url, payload);
                this.$toast.success(data.detail)
                await this.getSavedQueryList()

            }
            catch(error){
                console.log("error", error.response.data.detail)
                this.$toast.error(error.response.data.detail)
            }
            // console.log("saved ", saveQuery)
        },
        async updateQueryData(payload, queryId){
            try {
                let url = `/tenant-check/${this.$route.query.check}/pre-build-query/${queryId}`;
                let { data } = await mainAxios.put(url, payload);
                this.$toast.success(data?.detail);
                
            } catch (error) {
                console.log(error)
                this.$toast.error(error.response.data.detail);
            }
        },
        setCardStatusCounts() {
            if(this.isAllRunQueries){
                this.cardStatusCounts.all = this.totalRecordsInAllQueries
                this.cardStatusCounts.confirmedCount = this.totalStatusCount.CONFIRMED
                this.cardStatusCounts.unknownCount = this.totalStatusCount.UNKNOWN
                this.cardStatusCounts.potentialCount = this.totalStatusCount.POTENTIAL
                this.cardStatusCounts.irrelevantCount  = this.totalStatusCount.IRRELEVANT
            }
            else{
                this.cardStatusCounts.all = this.totalCount
                if (this.allFilters.length > 0) {
                    this.cardStatusCounts.confirmedCount = this.domainCompanyDetailsSearchList.filter((res) => res.card_status === 'CONFIRMED').length
                        + this.timeline.filter((res) => res.card_status === 'CONFIRMED').length,
                        this.cardStatusCounts.unknownCount = this.domainCompanyDetailsSearchList.filter((res) => !res.card_status || res.card_status === 'UNKNOWN').length
                        + this.timeline.filter((res) => !res.card_status || res.card_status === 'UNKNOWN').length,
                        this.cardStatusCounts.potentialCount = this.domainCompanyDetailsSearchList.filter((res) => res.card_status === 'POTENTIAL').length
                        + this.timeline.filter((res) => res.card_status === 'POTENTIAL').length,
                        this.cardStatusCounts.irrelevantCount = this.domainCompanyDetailsSearchList.filter((res) => res.card_status === 'IRRELEVANT').length
                        + this.timeline.filter((res) => res.card_status === 'IRRELEVANT').length
                }
                else {
                    this.cardStatusCounts.confirmedCount = this.cardStatusResults.filter((res) => res.card_status === 'CONFIRMED').length
                        + this.timeline.filter((res) => res.card_status === 'CONFIRMED').length,
                        this.cardStatusCounts.unknownCount = this.cardStatusResults.filter((res) => !res.card_status || res.card_status === 'UNKNOWN').length
                        + this.timeline.filter((res) => !res.card_status || res.card_status === 'UNKNOWN').length,
                        this.cardStatusCounts.potentialCount = this.cardStatusResults.filter((res) => res.card_status === 'POTENTIAL').length
                        + this.timeline.filter((res) => res.card_status === 'POTENTIAL').length,
                        this.cardStatusCounts.irrelevantCount = this.cardStatusResults.filter((res) => res.card_status === 'IRRELEVANT').length
                        + this.timeline.filter((res) => res.card_status === 'IRRELEVANT').length
                }
            }
        },
        async updateCardStatus() {
            await this.getAllCardsDetails();
            this.selectToolsCardStatus(null, this.tabsStatus.selected);
            if (this.page_number > this.getTotalPages)
                this.page_number = this.getTotalPages;
        },
        async updateTabCount(){
            if(this.isAllRunQueries){
                this.isNextPag = true;
                let sort = {
                    sort_by: this.order_by?.value || "",
                    sort_order: this.order_by?.value ? "desc" : ""
                }
                await this.onRunAllQueries(null, "domainCompanyDetailsSearch", sort);
                this.setCardStatusCounts()
            }
            else{
                await this.updateCardStatus();
            }
        },
        async getAllCardsDetails() {
            const payload = {
                case_id: this.getNeoCaseId,
                tool_name: this.$route.query.check_namee || this.autorun?.headers['x-tool-name'],
                entity_id: this.$route.query.entityId
            }
            if (!this.isAllRunQueries) payload["query_id"] = this.$route.query.query_id;

            const url = '/service/card-results'
            const { data } = await blackAxios.post(url, payload)
            if (data?.data.length > 0) {
                data.data.forEach((res) => {
                    this.cardDetailsMap[res.card_id] = res
                })
            }
            this.timeline.forEach((res) => {
                res.card_status = this.cardDetailsMap[res.api_all_data.doc_id] && this.cardDetailsMap[res.api_all_data.doc_id].status != 'None' ? this.cardDetailsMap[res.api_all_data.doc_id].status : 'UNKNOWN'
                res.customer_notes = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id].customer_notes : ''
                res.research_notes = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id].notes : ''
                res.risk_categories = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id].risk_categories : []
                res.bespoke = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id]?.bespoke : []
                res.entity_status = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id]?.entity_status : 'Red'
                res.screenshot = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id]?.screenshot : {}
            })
            this.timeline = cloneDeep(this.timeline)
            this.cardStatusResults.forEach((res) => {
                res.card_status = this.cardDetailsMap[res.api_all_data.doc_id] && this.cardDetailsMap[res.api_all_data.doc_id].status != 'None' ? this.cardDetailsMap[res.api_all_data.doc_id].status : 'UNKNOWN'
                res.customer_notes = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id].customer_notes : ''
                res.research_notes = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id].notes : ''
                res.risk_categories = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id].risk_categories : []
                res.bespoke = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id]?.bespoke : []
                res.entity_status = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id]?.entity_status : 'Red'
                res.screenshot = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id]?.screenshot : {}
            })
            this.domainCompanyDetailsSearch.forEach((res) => {
                res.card_status = this.cardDetailsMap[res.api_all_data.doc_id] && this.cardDetailsMap[res.api_all_data.doc_id].status != 'None' ? this.cardDetailsMap[res.api_all_data.doc_id].status : 'UNKNOWN'
                res.customer_notes = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id].customer_notes : ''
                res.research_notes = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id].notes : ''
                res.risk_categories = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id].risk_categories : []
                res.bespoke = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id]?.bespoke : []
                res.entity_status = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id]?.entity_status : 'Red'
                res.screenshot = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id]?.screenshot : {}
            })
            this.domainCompanyDetailsSearch = cloneDeep(this.domainCompanyDetailsSearch)
            this.setCardStatusCounts()
        },

        mapCardResultsData() {
            this.cardStatusResults.forEach((res) => {
                res.card_status = this.cardDetailsMap[res.api_all_data.doc_id] && this.cardDetailsMap[res.api_all_data.doc_id].status !== 'None' ?
                    this.cardDetailsMap[res.api_all_data.doc_id].status : 'UNKNOWN'
                res.customer_notes = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id].customer_notes : ''
                res.research_notes = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id].notes : ''
                res.risk_categories = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id].risk_categories : []
                res.bespoke = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id]?.bespoke : []
                res.entity_status = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id]?.entity_status : 'Red'
                res.screenshot = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id]?.screenshot : {}
            })
            this.domainCompanyDetailsSearch.forEach((res) => {
                res.card_status = this.cardDetailsMap[res.api_all_data.doc_id] && this.cardDetailsMap[res.api_all_data.doc_id].status !== 'None' ?
                    this.cardDetailsMap[res.api_all_data.doc_id].status : 'UNKNOWN'
                res.customer_notes = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id].customer_notes : ''
                res.research_notes = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id].notes : ''
                res.risk_categories = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id].risk_categories : []
                res.bespoke = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id]?.bespoke : []
                res.entity_status = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id]?.entity_status : 'Red'
                res.screenshot = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id]?.screenshot : {}
            })
        },

        async selectToolsCardStatus(_, id) {
            if (this.tabsStatus.selected === id) return; 
            if (this.timeline) {
                //    this.domainCompanyDetailsSearchList.forEach((res, index)=>{
                //        this.timeline.forEach((result, historyIndex)=>{
                //            if (index == historyIndex) {

                //            }
                //        })
                //    })
            }

            if (id !== this.tabsStatus.selected) this.page_number = 1

            this.tabsStatus.selected = id;
            if (this.isAllRunQueries) {
                this.isNextPag = true;
                this.offsetPag = 0;
                this.limitPag = 1;
                let sort = {
                    sort_by: this.order_by?.value || "",
                    sort_order: this.order_by?.value ? "desc" : ""
                }
                await this.onRunAllQueries(null, "domainCompanyDetailsSearch", sort);
                this.isNextPag = false;
                this.setCardStatusCounts();
            }
            if (id === "all") {
                this.domainCompanyDetailsSearch = this.cardStatusResults
            } else if (id === "unknown") {
                this.domainCompanyDetailsSearch = this.cardStatusResults.filter((res) => !res.card_status || res.card_status?.toLowerCase() === id)
            } else {
                this.domainCompanyDetailsSearch = this.cardStatusResults.filter((res) => res.card_status && res.card_status.toLowerCase() === id)
            }
            this.domainCompanyDetailsSearch = this.domainCompanyDetailsSearch
                .filter(item => item.api_all_data?.doc_id) // Remove entries with no doc_id
                .filter((item, index, self) =>
                    index === self.findIndex(t => t.api_all_data.doc_id === item.api_all_data.doc_id)
                );
                

            this.domainCompanyDetailsSearch = this.domainCompanyDetailsSearch.map((ele, index) => ({ ...ele, current_index: index }));

            this.handleCloseMoreInfo();
        },
        getMappingValue(data_values = [], source, mapValues, tag) {
            const result_dict = data_values.map((ele) => {
                let list = Object.entries(mapValues);
                const result = list.reduce((accumulator, item) => {
                    let keys = item[1][source].keys;
                    let separator = item[1][source].separator;
                    accumulator[item[0]] = keys
                        .map((key) => {
                            //Iterating inside array for fetching the values in "iterable_key"
                            if (item[1][source].iterable_key) {
                                return get(ele, key, []).map((el1) => get(el1, item[1][source].iterable_key, ""));
                            }
                            if (typeof item[1][source] === "object") {
                                return get(ele, key, []);
                            }
                            return get(ele, key, "N/A");
                        })
                        .filter((e) => e != null && e != "")
                        .join(separator ? separator : ", ");
                    return accumulator;
                }, {});
                result.key = source;
                result.sourceTag = tag;
                return { ...result, api_all_data: ele };
            });
            return result_dict;
        },
        resetPage() {
            this.page_number = 1;
            this.showMoreInfo = false;
            this.handleCloseMoreInfo();
        },
        onToggle() {
            this.open = !this.open;
        },
        handleOutside() {
            this.open = false;
        },
        resetStatus() {
            this.resetPage();
            this.showMoreInfo = false;
            this.selectedCard = null;
            this.isOldVersionSelected = false;
            this.timeline = [];
            this.$emit("updateMonitoringCascadingTimeline", {
                timeline: this.timeline,
                meta_data: null,
            });
            if ((this.sourceType === "companyWatch" || this.sourceType === "bvd") && this.fieldType.value === "officer") this.status = "";
        },
        resetJurisdiction() {
            if (this.sourceType === "bvd" && this.fieldType.value === "officer") this.jurisdictionType = "";
        },
        loadMoreCompanies() {
            let page = parseInt(this.openCorporateResults / 100, 10);
            this.loadMoreOpenCorporates(page + 1);
        },
        async handleBulkMonitoring() {
            // const monitoringStatus = event.target.checked;
            const querySource = this.autorun ? this.selectedQuery.query_payload : this.getSelectedToolQuery;
            this.isBulkMonntoringLoading = true;
            this.bulkMonitor = true;
            this.isBulkMonitorOn = !this.isBulkMonitorOn;
            let requestBody = {
                product_name: this.getProduct.name,
                product_id: this.getProduct.key,
                case_id: this.getNeoCaseId,
                query: {
                    query_id: querySource.query_id,
                    query_string: querySource.query_string,
                    search_string: querySource.search_string,
                },
                frequency: this.$props.frequency ? this.$props.frequency : 30,
                status: this.isBulkMonitorOn ? "enabled" : "disabled",
            };
            try {
                const response = await mainAxios.post("/service/bulk-enable", requestBody);
                if (response.status) {
                    this.$toast.success(this.$t('components.tools.company_identifier.bulk_monitoring_updated_successfully'));
                    this.bulkMonitor = false;
                    let details = this.domainCompanyDetailsSearch;
                    details.map((el) => {
                        el.api_all_data.monitoring_status = this.isBulkMonitorOn;
                    });
                    this.domainCompanyDetailsSearch = cloneDeep(details);

                    this.$forceUpdate();
                    // setTimeout(() => {
                    //     (this.manualSearch("true"),5000)
                    // });
                }
            } catch (error) {
                this.$toast.error(error.message);
            }
            this.isBulkMonntoringLoading = false;
        },

        loadMoreOpenCorporates(page) {
            this.startLoader("companySearch");
            const headers = {
                "x-tool-name": this.$route.params.toolName,
                "x-visited": true,
                ...this.autorun?.headers,
            };
            this.csvData = {
                company: [],
            };
            this.csvFields = [];
            let requestBody = {
                name: this.searchKeyword,
                code: this.jurisdiction?.value,
                request_id: this.sourcesCall?.request_id,
                page: page || 1,
                per_page: 100,
            };
            if (this.nerFilters) requestBody.output_filters = this.nerFilters;
            const openCorporates = mainAxios.post("/service/company/search", requestBody, {
                headers: {
                    ...headers,
                    "x-wlp-reference": process.env.VUE_APP_BACKEND_URL,
                    "x-status": 'RUNNING',
                    "x-case-id": this.getNeoCaseId,
                },
            });

            if (openCorporates) {
                Promise.allSettled([openCorporates])
                    .then(async (results) => {
                        let values = results.map((result) => result.value);
                        //OpenCorporates
                        if (values[0]?.data?.data?.length > 0) {
                            // CORPORATE_TOOL_MAPPING
                            const mappingValue = this.getMappingValue(values[0]?.data?.data, "openCorporates", CORPORATE_TOOL_MAPPING);
                            this.domainCompanyDetailsSearch = [...this.domainCompanyDetailsSearch, ...mappingValue];
                        }
                        this.totalOpenCorporateResults = resolveResponseTotalCount(values[0]);
                        this.openCorporateResults += values[0]?.data?.data?.length ?? 0;

                        this.csvData.company = this.convertToCSV(this.domainCompanyDetailsSearch);
                        this.csvFields = ["company_number", "company_name", "status", "address", "company_type", "jurisdiction", "incorporation_date"];

                        this.$emit("searchResult", { data: this.domainCompanyDetailsSearch, source: "company", searchType: "name" });

                        this.domainCompanyDetailsSearch = this.domainCompanyDetailsSearch.map((ele, index) => ({ ...ele, current_index: index }));
                        this.totalResults = this.domainCompanyDetailsSearch.length;
                        this.resetLoader("companySearch");

                        if (results[0]?.status === "rejected" || values[0]?.status === 500) {
                            this.$toast.error(this.$t('components.tools.company_identifier.opencorporates_something_went_wrong_please_try_again'));
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        this.$toast.error(this.$t('general.default_error2'));
                        this.resetLoader("companySearch");
                    });
            }
        },

        async autoInit() {
            try {
                this.isLoading = true;
                this.showSearch = false;

                // TODO enable sources based on user permissions
                if (this.title === "Corporate Record-DNB")
                    this.dnbCheck = true;
                if (this.title === "Corporate Records") 
                    this.bvdCheck = true;

                await this.manualSearch();
                await this.getAllCardsDetails();
                await this.getToolsStatus();
                const confirmedCards = this.cardStatusResults.filter((res) => res.card_status === 'CONFIRMED');
                for (const index in confirmedCards)
                    this.handleCorporateRecordsConfirmation({
                        item: confirmedCards[index],
                        value: true
                    });
            } catch (error) {
                console.error(error);
            } finally {
                this.isLoading = false;
            }
        },

        async manualSearch(refreshFlag = false, fromSelectOption = false) {
            if (!this.isRunCheckAllowed) {
                return this.showRunCheckError();
            }

            this.triggerRoute = false;
            this.showResult = true;
            
            if (refreshFlag) this.monitoringActive = false;
            if (fromSelectOption) {
                console.log(fromSelectOption)
                let preservedOrderBy = this.order_by;
                await this.search(refreshFlag, false, fromSelectOption);
                this.order_by = preservedOrderBy;
            } else {
                await this.search(refreshFlag);
            }
            this.isloadingDetails = false;
        },

        async getToolData() {
            this.allUsers = await this.getDropdownData("company_name");
        },

        async getDropdownData(field) {
            let data = this.toolData.filter((user) => user.val_type === field);
            return data;
        },

        handleChecked(data) {
            let allChecked = false;
            this.allUsers =  this.allUsers.filter((el) => el?.platform == "company-identifier" && el.entity_id == this.$route.query.entityId)
            this.$emit("updateToolData", "company-identifier", [...this.allUsers], data);
            allChecked = [...this.allUsers].length ? ([...this.allUsers].findIndex((n) => !n.visited) > -1 ? false : true) : false;

            this.$emit("handleChecked", allChecked);
        },

        setInput() {
            this.searchKeyword = this.selectedItem.value;
        },

        setTheCustomInput(value) {
            this.searchKeyword = value;
            this.selectedItem = {
                value: value,
            };
        },

        updateFieldType(i) {
            if (i >= 0) {
                this.queries[i].company = "";
                this.queries[i].officer = "";
                this.queries[i].address = "";
                this.queries[i].registry.firstName = "";
                this.queries[i].registry.middleName = "";
                this.queries[i].registry.lastName = "";
                this.queries[i].registry.nickname = "";
                this.isAllRunQueries = false;
            } else {
                this.officer = "";
                this.address = "";
                this.searchKeyword = "";
                this.selectedItem = "";
                this.jurisdiction = "";
                this.companyType = "";
                this.sourceType = "";
                this.jurisdictionType = "";
                this.searchQuery = "";
                this.status = "";
                this.registry.firstName = "";
                this.registry.middleName = "";
                this.registry.lastName = "";
                this.registry.nickname = "";
                this.showResult = false;
                this.showSearch = true;
                this.isAllRunQueries = false;
                this.selectVal = [];
                this.csvData = {
                    company: [],
                };
                this.csvFields = [];
            }
        },

        async setSearchedUser(searchKeyword) {
            const data = {
                value: searchKeyword,
                platform: "company-identifier",
                val_type: this.selectedItem?.val_type || "company_name",
                visited: true,
                entity_id: this.$route.query.entityId
            };
            let url = `/service/${this.getNeoCaseId}/tools/profiles`;
            await setUsernamesDropdownData(url, data);
            // if (isSuccess) {
            let dataItem = this[`allUsers`].find((dataItem) => {
                return dataItem.value === searchKeyword;
            });
            if (dataItem) dataItem["visited"] = true;
            else if (data?.value) {
                this[`allUsers`].push(data);
                this.$emit("addCustomData", data);
            }
            this.handleChecked(data);
            // }
        },

        async getJurisdiction() {
            // let url = "/api/v1/company/search/jurisdiction";
            let url = "tenant-check/jurisdictions";
            await mainAxios
                .get(url)
                .then((response) => {
                    if (response && response.data) {
                        const jurisdiction = response.data.map((el) => ({
                            label: el.name,
                            value: el.alpha_2_code.toLowerCase(),
                            aka: el.aka
                        }));
                        this.jurisdictionList = [{ group: this.dropOptionsGroupTranslation.jurisdiction, categories: jurisdiction }];
                        this.$store.dispatch("storeAllJurisdiction", jurisdiction);
                        
                    }
                })
                .catch(() => { });
        },

        getJurisdictionDisplayName(code) {
            return code;
        },

        getJurisdictionFlag(code) {
            code = code.toLowerCase();
            const country_code = code.split("_")[0];
            return this.$store.getters?.getIconsData?.find((e) => e.key == `flag_${country_code}`)?.icon_data ?? "";
        },





        showMore(id, code) {
            this.getMoreCompanyDetails(id, code);
        },
        async getMoreCompanyDetails(companyNumber, code) {
            let requestBody = {
                number: companyNumber,
                code: code,
            };
            const response = await mainAxios.post("/service/company/search/id", {
                headers: { 
                    "x-wlp-reference": `${process.env.VUE_APP_BACKEND_URL}`,
                    "x-status": 'RUNNING',
                    "x-case-id": this.getNeoCaseId,
                },
            }, requestBody);
            try {
                if (response && response.data && response.data.data) {
                    this.fullDetails = response.data.data;
                    map(this.domainCompanyDetailsSearch, (item) => (item.company.company_number === companyNumber ? extend(item, { more: this.fullDetails }) : item));
                    this.$set(this.readMore, companyNumber, true);
                    if (this.tabName === "tools") {
                        this.SET_ALL_TOOLS_DATA({
                            ...this._data,
                            "tool-name": "company-name",
                        });
                    } else {
                        this.SET_ALL_MONITORING_DATA({
                            ...this._data,
                            "tool-name": "company-name",
                        });
                    }
                }
            } catch (error) { console.log(error) }
        },
        async getdomainCompanyDetails(i) {
            this.startLoader("companySearch");
            let requestBody = {
                domain: this.searchKeyword,
            };
            const response = await osintAxios.post("/api/v1/domain/company", requestBody);
            try {
                if (response && response.data && response.data.data) {
                    this.domainCompanyDetails = response.data.data;
                    // Calling company details Search
                    this.getdomainCompanyDetailsSearch(this.domainCompanyDetails.name, i);
                }
                this.resetLoader("companySearch");
                if (this.tabName === "tools") {
                    this.SET_ALL_TOOLS_DATA({
                        ...this._data,
                        "tool-name": "company-name",
                    });
                } else {
                    this.SET_ALL_MONITORING_DATA({
                        ...this._data,
                        "tool-name": "company-name",
                    });
                }
            } catch (error) { console.log("error") }
        },
        async getdomainCompanyDetailsSearch(companyName, i) {
            this.startLoader("companySearch");
            let requestBody = {
                name: companyName,
                code: this.jurisdiction?.value,
            };
            this.csvData = {
                company: [],
            };
            this.csvFields = [];
            const response = await mainAxios.post("/service/company/search", requestBody, {
                headers: {
                    "x-tool-name": this.$route.params.toolName,
                    "x-visited": true,
                    "x-wlp-reference": process.env.VUE_APP_BACKEND_URL,
                    "x-status": 'RUNNING',
                    "x-case-id": this.getNeoCaseId,
                    ...this.autorun?.headers,
                },
            });
            try {
                if (i === 0) {
                    // this.successLoader();
                    if (response && response.data && response.data.data?.length) {
                        this.domainCompanyDetailsSearch = response.data.data;
                        // this.csvData.company = this.convertToCSV(this.domainCompanyDetailsSearch.map((item) => item.company));
                        // this.csvFields = ["name", "registered_address_in_full", "company_number", "company_type", "jurisdiction_code", "updated_at", "current_status", "incorporation_date", "opencorporates_url", "registry_url"];
                        this.csvData.company = this.convertToCSV(this.domainCompanyDetailsSearch);
                        this.csvFields = ["company_number", "company_name", "status", "address", "company_type", "jurisdiction", "incorporation_date"];
                        this.showResult = true;
                        this.showSearch = false;
                        this.$emit("searchResult", { data: this.domainCompanyDetailsSearch, source: "company", searchType: "name" });
                    } else if (response) {
                        this.$toast.error(this.$t('components.tools.company_identifier.no_data_found'));
                    }
                    this.resetLoader("companySearch");
                    if (this.tabName === "tools") {
                        this.SET_ALL_TOOLS_DATA({
                            ...this._data,
                            "tool-name": "company-name",
                        });
                    } else {
                        this.SET_ALL_MONITORING_DATA({
                            ...this._data,
                            "tool-name": "company-name",
                        });
                    }
                }
            } catch (error) {
                this.resetLoader("companySearch");
            }
        },
        async getdomainCompanyAddressSearch(address, i, refreshFlag) {
            this.startLoader("companySearch");
            const headers = {
                "x-tool-name": this.$route.params.toolName,
                "x-visited": true,
                "x-refresh": refreshFlag || false,
                ...this.autorun?.headers,
            };

            let data = {
                address: i === 0 ? this.address : this.queries[i - 1].address,
                sources: ["opencorporates"],
            };
            const { data: sourcesCall } = await mainAxios.post("/service/company/search/sources", data, {  headers: {
                ...headers,
                "x-wlp-reference": process.env.VUE_APP_BACKEND_URL,
                "x-status": 'RUNNING',
                "x-case-id": this.getNeoCaseId,
            }, });
            let { request_id } = sourcesCall;
            this.request_id = sourcesCall.request_id;
            this.redirectTo();

            let requestBody = {
                address,
                request_id,
            };
            this.csvData = {
                company: [],
            };
            if (this.monitoringActive && !this.isAllRunQueries) {
                this.showSearch = false;
                this.showResult = true;
                // await this.monitoringSearch(sources, "company");
                this.domainCompanyDetailsSearch = [];
                this.resetLoader("companySearch");
                return;
            }
            const response = await mainAxios.post("/service/company/search/address", requestBody, {
                headers: {
                    "x-tool-name": this.$route.params.toolName,
                    "x-visited": true,
                    "x-wlp-reference": `${process.env.VUE_APP_BACKEND_URL}`,
                    "x-status": 'RUNNING',
                    "x-case-id": this.getNeoCaseId,
                    ...this.autorun?.headers,
                },
            });
            try {
                if (i === 0) {
                    // this.successLoader();
                    if (response && response.data && response.data.data.length) {
                        this.domainCompanyDetailsSearch = this.getMappingValue(response.data.data, "address", CORPORATE_TOOL_MAPPING).map((ele, index) => ({ ...ele, current_index: index }));
                        this.csvData.company = this.convertToCSV(this.domainCompanyDetailsSearch);
                        this.csvFields = ["company_number", "company_name", "status", "address", "company_type", "jurisdiction", "incorporation_date"];
                        this.showSearch = false;
                        this.showResult = true;
                    } else if (response && response.data) {
                        this.$toast.error(this.$t('components.tools.company_identifier.no_data_found'));
                    }
                    this.$emit("searchResult", { data: this.domainCompanyDetailsSearch, source: "company", searchType: "address" });
                    this.triggerRoute = true;
                    this.resetLoader("companySearch");
                    this.$emit("getInitialQueryCount");
                    if (this.tabName === "tools") {
                        this.SET_ALL_TOOLS_DATA({
                            ...this._data,
                            "tool-name": "company-name",
                        });
                    } else {
                        this.SET_ALL_MONITORING_DATA({
                            ...this._data,
                            "tool-name": "company-name",
                        });
                    }
                }
            } catch (error) {
                if (error.response && error.response.status === 406) {
                    const message = error.response?.data?.detail || "Something went wrong. Please try again.";
                    this.$toast.error(message);
                }
                this.resetLoader("companySearch");
            }
        },
        async getOfficerSearch(i, refreshFlag) {
            if (this.autorun) {
                if([CORPORATE_RECORDS_CHECK_ID].includes(this.sourceId)){
                   this.bvdCheck = true 
                }
                if([DNB_CHECK_ID].includes(this.sourceId)) {
                    this.dnbCheck = true 
                    // sources.push("db");
                }
                if (this.selectedQuery?.query.sources[0] === "openCorporates") {
                    this.openCorporatesCheck = true 
                    // sources.push("openCorporates");
                }
            }
            if (!this.openCorporatesCheck && !this.clarifiedByCheck && !this.companyWatchCheck && !this.bvdCheck) {
                this.showResult = false
                this.$toast.error(ErrorMessages.RequiredSources);
                return;
            }
            this.startLoader("companySearch");

            const headers = {
                "x-tool-name": this.$route.query.check_name,
                "x-visited": true,
                "x-refresh": refreshFlag || false,
                "x-entity-id": this.$route.query.entityId,
                ...this.autorun?.headers,
            };
            this.csvData = {
                company: [],
            };
            this.csvFields = [];

            let openCorporates, clarifiedBy, companyWatch, bvd;
            let sources = [];
            if (this.openCorporatesCheck) {
                sources.push("openCorporates");
            }
            if (this.clarifiedByCheck) {
                sources.push("clarifiedBy");
            }
            if (this.companyWatchCheck) {
                sources.push("companyWatch");
            }
            if (this.bvdCheck) {
                sources.push("bvd");
            }
            if (this.monitoringActive && !this.isAllRunQueries) {
                await this.monitoringSearch(sources, "officer");
                return;
            }
            let data = "";
            if (this.companyWatchCheck) {
                data = {
                    officer: this.officer,
                    mode: this.searchMode?.value?.value,
                    sources: sources.map((el) => el.toLowerCase()).sort((a, b) => a.localeCompare(b)),
                };
            } else {
                data = {
                    officer: this.officer,
                    code: this.jurisdiction?.value,
                    sources: sources.map((el) => el.toLowerCase()).sort((a, b) => a.localeCompare(b)),
                };
                if(this.bvdCheck && this.fieldType.value === 'officer') {
                    if(this.getDob()) {
                        data.dobfrom = this.getDob();
                    }
                    if(this.selectedNationalityFilter) {
                        data.nationality =  [this.selectedNationalityFilter?.label]
                    }
                    if(this.selectedCountryFilter) {
                        data.countryofresidence = [this.selectedCountryFilter?.label]
                    }
                }
                if(this.bvdCheck && this.fieldType.value === 'company') {
                    if(this.selectedJurisdictionFilter) {
                        // data.city = this.selectedJurisdictionFilter?.label || "";
                        data.country =  this.selectedJurisdictionFilter?.value || "";
                    }
                }
            }

            // add prebuilt query:
            Object.assign(data, this.prebuiltOfficerQueryPayload);

            const {data: sourcesCall} = await mainAxios.post("/service/company/search/sources", data, { headers: {
                ...headers,
                "x-wlp-reference": process.env.VUE_APP_BACKEND_URL,
                "x-status": 'RUNNING',
                "x-case-id": this.getNeoCaseId,
            },});
            const queryExists = this.searchedQueries.some((res)=>res._id==sourcesCall.request_id)
            if (!queryExists) {
                this.monitoringActive = false
            }
            this.request_id = sourcesCall.request_id;
            this.redirectTo();
            if (this.openCorporatesCheck) {
                let requestBody = {
                    officer:this.officer,
                    code: this.jurisdiction?.value,
                    request_id: sourcesCall.request_id,
                    ...this.prebuiltOfficerQueryPayload,
                };
                if (this.nerFilters) requestBody.output_filters = this.nerFilters;
                openCorporates = await osintAxios.post("/api/v1/company/search/person", requestBody, {
                    headers,
                });
            }
            if (this.bvdCheck) {
                let requestBody = {
                    name: this.officer,
                    request_id: sourcesCall.request_id,
                    ...this.prebuiltOfficerQueryPayload,
                };
                if(this.fieldType.value === 'officer') {
                    if(this.getDob()) {
                        requestBody.dobfrom = this.getDob();
                    }
                    if(this.selectedNationalityFilter) {
                        requestBody.nationality =  [this.selectedNationalityFilter?.label]
                    }
                    if(this.selectedCountryFilter) {
                        requestBody.countryofresidence = [this.selectedCountryFilter?.label]
                    }
                }
                if (this.nerFilters) requestBody.output_filters = this.nerFilters;

                const query_payload = await this.getQueryPayload(requestBody, "bvd");
                bvd = await osintAxios.post("/api/v1/company/bvd/person", query_payload, {
                    headers,
                });
            }
            if ((openCorporates || bvd)) {
                this.domainCompanyDetailsSearch = [];
                
                Promise.allSettled([openCorporates, clarifiedBy, companyWatch, bvd])
                    .then(async (results) => {
                        
                        let values = results.map((result) => result.value);
                        let configMissing = this.checkConfig(values)
                        if (configMissing.length>0) {
                            configMissing.forEach((mes)=>{
                                this.$toast.error(mes)
                            })
                            return
                        }
                        this.domainCompanyDetailsSearch = [];
                        
                        //OpenCorporates
                        if (values[0]?.data?.data?.length > 0) {
                            this.totalCount = resolveResponseTotalCount(values[0]);
                            const mappingValue = this.getMappingValue(values[0]?.data?.data, "officer", CORPORATE_TOOL_MAPPING, "openCorporates");
                            this.domainCompanyDetailsSearch = [...this.domainCompanyDetailsSearch, ...mappingValue];
                            // length = this.domainCompanyDetailsSearch.length;
                            this.showSearch = false;
                            this.showResult = true;
                        }
                        //ClarifiedBy
                        if (values[1]?.data?.data?.length > 0) {
                            this.totalCount += resolveResponseTotalCount(values[1]);
                            let countries = values[1]?.data?.facets?.find((facets) => facets.name === "country_codes")?.buckets;
                            let mappingValue = this.getMappingValue(values[1]?.data?.data, "officer_clarifiedBy", CORPORATE_TOOL_MAPPING, "clarifiedBy");
                            mappingValue = mappingValue.map((company) => ({
                                ...company,
                                jurisdiction: countries?.find((country) => country.name === company?.api_all_data?.country_of_residence?.name_en)?.code,
                            }));
                            this.domainCompanyDetailsSearch = [...this.domainCompanyDetailsSearch, ...mappingValue];

                            // length = this.domainCompanyDetailsSearch.length;
                            this.showSearch = false;
                            this.showResult = true;
                            // this.$emit("searchResult", { data: this.domainCompanyDetailsSearch, source: "company", searchType: "name" });
                        }
                        //companyWatch
                        if (values[2]?.data?.data?.length > 0) {
                            this.totalCount += resolveResponseTotalCount(values[2]);
                            const mappingValue = this.getMappingValue(values[2]?.data?.data, "officer_companyWatch", CORPORATE_TOOL_MAPPING, "companyWatch");
                            this.domainCompanyDetailsSearch = [...this.domainCompanyDetailsSearch, ...mappingValue];
                            // length = this.domainCompanyDetailsSearch.length;
                            this.showSearch = false;
                            this.showResult = true;
                            // this.$emit("searchResult", { data: this.domainCompanyDetailsSearch, source: "company", searchType: "name" });
                        }
                        // bvd
                        if (values[3]?.data?.data?.length > 0) {
                            this.totalCount += resolveResponseTotalCount(values[3]);
                            let results = [];
                            let start = results.length;
                            results = [...results, ...values[3]?.data?.data];
                            for (let i = start; i < results.length; i++) {
                                results[i] = {
                                    ...results[i],
                                    ...{
                                        officerName: results[i].CONTACTS_HEADER_FULLNAME,
                                        directorId: results[i].CONTACTS_HEADER_IdDirector,
                                        country: results[i].CONTACTS_HEADER_HomeCountry,
                                        doc_id: results[i].doc_id,
                                        query_id: sourcesCall.request_id,
                                    },
                                };
                            }
                            // results = uniqBy(
                            //     results.map((item) => ({
                            //         ...item,
                            //         key: "officer_bvd",
                            //     })),
                            //     "CONTACTS_MEMBERSHIP_IdCompany"
                            // );

                            const mappingValue = this.getMappingValue(results, "officer_bvd", CORPORATE_TOOL_MAPPING, "bvd");
                            this.domainCompanyDetailsSearch = [...this.domainCompanyDetailsSearch, ...mappingValue];
                            // length = this.domainCompanyDetailsSearch.length;
                            this.showSearch = false;
                            this.showResult = true;
                            // this.$emit("searchResult", { data: this.domainCompanyDetailsSearch, source: "company", searchType: "name" });
                        }

                        if ((!results[0]?.status === "rejected" && (!values[0]?.data?.data || values[0]?.data?.data?.length === 0)) && (!results[1]?.status === "rejected" && (!values[1]?.data?.data || values[1]?.data?.data?.length === 0)) && (!results[2]?.status === "rejected" && (!values[2]?.data?.data || values[2]?.data?.data?.length === 0)) && (!results[3]?.status === "rejected" && (!values[3]?.data?.data || values[3]?.data?.data?.length === 0))) {
                            if (values[0]?.data?.message || values[1]?.data?.message || values[2]?.data?.message || values[3]?.data?.detail || values[4]?.data?.message) this.$toast.error(values[0]?.data?.message || values[1]?.data?.message || values[2]?.data?.message || values[3]?.data?.message);
                            else this.$toast.error(this.$t('components.tools.company_identifier.no_data_found'));
                        }

                        if (results[0]?.status === "rejected" || values[0]?.status === 500) {
                            this.showSearch = false;
                            this.showResult = true;
                            this.$toast.error(this.$t('components.tools.company_identifier.opencorporates_something_went_wrong_please_try_again'));
                        }
                        if (results[1]?.status === "rejected" || values[1]?.status === 500) {
                            this.showSearch = false;
                            this.showResult = true;
                            this.$toast.error(this.$t('components.tools.company_identifier.clarifiedby_something_went_wrong_please_try_again'));
                        }
                        if (results[2]?.status === "rejected" || values[2]?.status === 500) {
                            this.showSearch = false;
                            this.showResult = true;
                            this.$toast.error(this.$t('components.tools.company_identifier.companywatch_something_went_wrong_please_try_again'));
                        }
                        if (results[3]?.status === "rejected" || values[3]?.status === 500) {
                            this.showSearch = false;
                            this.showResult = true;
                            this.$toast.error(this.$t('components.tools.company_identifier.bvd_something_went_wrong_please_try_again'));
                        }
                        this.csvData.company = this.convertToCSV(this.domainCompanyDetailsSearch);
                        this.csvFields = ["company_number", "company_name", "status", "address", "company_type", "jurisdiction", "incorporation_date"];

                        if (this.domainCompanyDetailsSearch.length) {
                            this.domainCompanyDetailsSearch = this.domainCompanyDetailsSearch.map((ele, index) => ({ ...ele, current_index: index }));
                            // this.domainCompanyDetailsSearch = mappingValue;
                        } else {
                            this.showSearch = false;
                            this.showResult = true;
                        }
                        this.domainCompanyDetailsSearch.forEach((res) => {
                            res.card_status = this.cardDetailsMap[res.api_all_data.doc_id] && this.cardDetailsMap[res.api_all_data.doc_id].status != 'None' ? this.cardDetailsMap[res.api_all_data.doc_id].status : 'UNKNOWN'
                            res.customer_notes = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id].customer_notes : ''
                            res.research_notes = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id].notes : ''
                            res.risk_categories = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id].risk_categories : []
                            res.bespoke = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id]?.bespoke : []
                            res.entity_status = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id]?.entity_status : 'Red'
                            res.screenshot = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id]?.screenshot : {}
                        })
                        this.cardStatusResults = this.domainCompanyDetailsSearch
                        this.setCardStatusCounts()
                        this.$emit("searchResult", { data: this.domainCompanyDetailsSearch, source: "company", searchType: "name" });
                        this.triggerRoute = true;
                        this.$emit("getInitialQueryCount");
                        this.resetLoader("companySearch");
                        if (this.tabName === "tools") {
                            this.SET_ALL_TOOLS_DATA({
                                ...this._data,
                                "tool-name": "company-name",
                            });
                        } else {
                            this.SET_ALL_MONITORING_DATA({
                                ...this._data,
                                "tool-name": "company-name",
                            });
                        }

                        this.$emit("updateQueryTotal", { checkName: this.$route.query.check_name });
                        await this.afterSearchResponseReceived({ 
                            searchResults: results 
                        });

                        this.$emit("updateToolData", "company-name");
                    })
                    .catch((error) => {
                        if (error.response && error.response.status === 406) {
                            const message = error.response?.data?.detail || this.$t('general.default_error2');
                            this.$toast.error(message);
                        }
                        this.showSearch = false;
                        this.showResult = true;
                        this.resetLoader("companySearch");
                    });
            }
        },
        startLoader(section) {
            this.loaderController[section].success = false;
            this.loaderController[section].loading = true;
        },
        successLoader(section) {
            this.loaderController[section].success = true;
            this.loaderController[section].loading = false;
        },
        resetLoader(section) {
            this.loaderController[section].success = false;
            this.loaderController[section].loading = false;
        },
        onPerPageChange(itemsCount) {
            this.items_count = itemsCount;
            this.page_number = 1;
        },
        paginateTweets(pageNo) {
            this.pagination.tweets.page = pageNo;
            if (this.selectedTab === "tweets") {
                this.getTweets();
            }
        },
        formatDate(dt) {
            let parsed_dt = DateTime.fromISO(dt);
            if (!parsed_dt.invalid) return parsed_dt.toFormat("EEE, MMM dd yyyy");
            return dt;
        },

        getCount(count) {
            return count >= 1000 ? (count / 1000).toFixed(1) + "K" : count;
        },

        getTime(item) {
            let date = new Date(item.created_at);
            return date ? date.getDate() + "/" + (parseInt(date.getMonth(), 10) + 1) + "/" + date.getFullYear() : "";
        },

        async openShowMorePanel(company) {
            if (company.key === "db") {
                await this.fetchMoreData(company);
                this.fetchMoreLoading = true;
            }
            console.log(company)
            this.selectedCard =  company.current_index !== null &&  company.current_index !== undefined ? company.current_index : company.curr_index;
            const isOldVersion = company.isOldVersion;
            if (isOldVersion) {
                this.isOldVersionSelected = true;
                this.companyDetails = this.timeline[this.selectedCard];
            } else {
                this.isOldVersionSelected = false;
                this.companyDetails = this.domainCompanyDetailsSearch[this.selectedCard];
            }
            // this.modalCompanyDetailsDataMore = company;
            this.showMoreInfo = true;
            setTimeout(() => {
                document.getElementById(`company-${company.index}`)?.scrollIntoView();
            }, 100);
        },
        async showMoreData(company) {
            const { panelsDetails } = company;
            const handleExpandAllFlag = company.handleExpandAllFlag;
            // this.selectedCard = company.index;
            if (company.key === "openCorporates" || company.key === "officer" || company.key == "address") {
                company = { ...company, isLoading: true };
                let requestBody;
                if (company.key === "openCorporates") {
                    requestBody = {
                        number: company.company_number,
                        code: company.jurisdiction || company?.api_all_data?.officer.jurisdiction_code,
                        query_id: company.api_all_data.query_id || this.getSelectedToolQuery.query_id,
                        card_type: company.key === "openCorporates" ? "company" : "officer",
                        doc_id: company.api_all_data.doc_id,
                    };
                }
                if (company.key === "officer") {
                    requestBody = {
                        number: company.company_number,
                        code: company.jurisdiction || company?.api_all_data?.officer.jurisdiction_code,
                        query_id: company.api_all_data.query_id || this.getSelectedToolQuery.query_id,
                        officer_id: company.api_all_data.officer.id,
                        card_type: "officer",
                        doc_id: company.api_all_data.doc_id,
                    };
                } else
                    requestBody = {
                        number: company.company_number,
                        code: company.jurisdiction || company?.api_all_data?.officer.jurisdiction_code,
                        query_id: company?.api_all_data?.query_id || this.getSelectedToolQuery.query_id,
                        card_type: "company",
                        doc_id: company.api_all_data.doc_id,
                    };

                if (!company.expanded) {
                    company.loadingMore = true;
                    this.$forceUpdate();
                }
                const response = await mainAxios.post("/service/company/search/id", {
                    headers: { 
                        "x-wlp-reference": `${process.env.VUE_APP_BACKEND_URL}`,
                        "x-status": 'RUNNING',
                        "x-case-id": this.getNeoCaseId,
                    },
                }, requestBody);
                const { data: chain_data } = await osintAxios.post("/api/v1/company/search/chain", {
                    comp_id: company.company_number,
                });
                company.loadingMore = false;
                company.modalCompanyDetailsData = response.data.data;
                if (company?.modalCompanyDetailsData?.company) {
                    company.modalCompanyDetailsData.company.chain_data = chain_data;
                    const nodes = company.modalCompanyDetailsData.company?.chain_data?.entity?.map((ele) => {
                        let node = {
                            type: "node",
                            id: ele._id,
                            t: ele.name,
                            // u: require(`@/assets/icons/flags/${ele.jurisdiction[0].code.split("_")[0].toLowerCase()}.svg`),
                        };
                        if (ele.main_node) {
                            node.ha0 = {
                                c: "#0d69d5", // the halo fill colour
                                r: 100, // the halo radius
                                w: 5, // the halo width
                            };
                        }

                        if (ele?.jurisdiction?.length > 0 && ele?.jurisdiction[0]?.code) {
                            node.g = [
                                {

                                    p: 305,
                                    r: 40,
                                },
                            ];
                        }
                        return node;
                    });
                    const edges = company.modalCompanyDetailsData?.company?.chain_data?.relations.map((ele, i) => ({ type: "link", id: `${i + 1}_edge`, id1: ele.from, id2: ele.to, w: ele.active ? 2 : 1, a2: ele.from, c: ele.active ? "#000000" : "#AAAAAA" }));
                    const graph_data = {
                        type: "LinkChart",
                        items: [...nodes, ...edges],
                    };
                    company.modalCompanyDetailsData.company.graph_data = graph_data;
                }
                // this.modalCompanyDetailsDataMore = company.modalCompanyDetailsData;
                company = { ...company, ...company.modalCompanyDetailsData };
                company.fetched = true;
                this.$emit("searchResult", { data: [company].map((ele) => ({ ...ele, ...(ele.modalCompanyDetailsData?.company ?? {}) })), source: "company", searchType: "name" });
                company = { ...company, isLoading: false };
            } else if (company.key === "clarifiedBy" || company.key === "officer_clarifiedBy") {
                // company.fetched = true;
                let requestBody = {
                    comp_id: company.api_all_data.subject_id,
                    type: company.key === "clarifiedBy" ? "organisations" : "individuals",
                    request_id: company.api_all_data.query_id || this.getSelectedToolQuery.query_id,
                    doc_id: company.api_all_data.doc_id,
                };
                let url = `/api/v1/company/clarifiedby/${company.api_call_type}`;
                const { data } = await osintAxios.post(url, requestBody);
                if (company.api_call_type === "detail") {
                    company = { ...company, summary: data.results, fetchedSummary: true, summaryExpanded: !company.summaryExpanded };
                    // let officers = data?.results?.results?.map((ele) => ({ officer: { name: get(ele, "entity_name.name_en") } })) ?? [];
                    // this.$emit("searchResult", { data: [company].map((ele) => ({ ...ele, officers })), source: "company", searchType: "name" });
                }
                if (company.api_call_type === "ownership") {
                    company = { ...company, ownership: data.results, fetchedOwnership: true, ownershipExpanded: !company.ownershipExpanded };
                    const officers = data?.results?.results?.map((ele) => ({ officer: { name: get(ele, "entity_name.name_en"), entity_type: get(ele, "entity_type", "") } })) ?? [];
                    this.$emit("searchResult", { data: [company].map((ele) => ({ ...ele, officers })), source: "company", searchType: "name" });
                }
                if (company.api_call_type === "management") {
                    company = { ...company, management: data.results, fetchedManagement: true, managementExpanded: !company.managementExpanded };
                    const officers = data?.results?.results?.map((ele) => ({ officer: { name: get(ele, "entity_name.name_en", ""), entity_type: get(ele, "entity_type", "") } })) ?? [];
                    this.$emit("searchResult", { data: [company].map((ele) => ({ ...ele, officers })), source: "company", searchType: "name" });
                }
                if (company.api_call_type === "holdings") {
                    company = { ...company, holdings: data.results, fetchedHoldings: true, holdingsExpanded: !company.holdingsExpanded };
                    const officers = data?.results?.results?.map((ele) => ({ officer: { name: get(ele, "entity_name.name_en", ""), entity_type: get(ele, "entity_type", "") } })) ?? [];
                    this.$emit("searchResult", { data: [company].map((ele) => ({ ...ele, officers })), source: "company", searchType: "name" });
                }
                if (company.api_call_type === "activities") {
                    company = { ...company, activities: data.results, fetchedActivities: true, activitiesExpanded: !company.activitiesExpanded };
                    const officers = data?.results?.regulators?.map((ele) => ({ officer: { name: get(ele, "entity_name.name_en", ""), entity_type: get(ele, "entity_type", "") } })) ?? [];
                    this.$emit("searchResult", { data: [company].map((ele) => ({ ...ele, officers })), source: "company", searchType: "name" });
                }
                // company.fetchedSummary = true;
            } else if (company.key === "officer_companyWatch") {
                let requestBody = {
                    person_number: company.api_all_data.directorNumber,
                    code: company.api_all_data.productCode,
                    query_id: company.api_all_data.query_id || this.getSelectedToolQuery.query_id,
                    doc_id: company.api_all_data.doc_id,
                };
                let url = `/api/v1/company/company-watch/person/${company.api_call_type}`;
                if (company.api_call_type === "CurrentAppointments") {
                    url = `/api/v1/company/company-watch/person/current-appointments`;
                } else if (company.api_call_type === "PreviousAppointments") {
                    url = `/api/v1/company/company-watch/person/previous-appointments`;
                }

                const { data } = await osintAxios.post(url, requestBody);
                company = {
                    ...company,
                    [`${company.api_call_type}`]: data.data,
                    [`fetched${company.api_call_type}`]: true,
                    [`${company.api_call_type}Expanded`]: !company[`${company.api_call_type}Expanded`],
                };

                if (handleExpandAllFlag && company.api_call_type === "CurrentAppointments") {
                    await this.showMoreData({ ...company, api_call_type: "PreviousAppointments" });
                }
                this.$emit("searchResult", { data: this.domainCompanyDetailsSearch, source: "company", searchType: "name" });
            } else if (company.key === "companyWatch") {
                company = { ...company, isLoading: true };
                let requestBody = {
                    number: company?.api_all_data?.id,
                    code: company?.api_all_data?.productCode,
                    card_type: "company",
                    request_id: company?.api_all_data?.query_id || this.getSelectedToolQuery.query_id,
                    doc_id: company.api_all_data.doc_id,
                };
                let url = `/api/v1/company/company-watch/detail`;
                const { data } = await osintAxios.post(url, requestBody);
                company = { ...company };
                const previous_directors = data?.data?.previous_directors?.map((ele) => ({ officer: { name: ele.directorName, entity_type: ele.entityType ?? "" } })) ?? [];
                const current_directors = data?.data?.current_directors?.map((ele) => ({ officer: { name: ele.directorName, entity_type: ele.entityType ?? "" } })) ?? [];
                const officers = [...previous_directors, ...current_directors];
                company = {
                    ...company,
                    [`fetched${company.api_call_type}`]: true,
                    [`${company.api_call_type}Expanded`]: !company[`${company.api_call_type}Expanded`],
                    isLoading: false,
                };
                company.api_all_data = { ...company.api_all_data, ...data.data };
                this.$emit("searchResult", { data: [company].map((ele) => ({ ...ele, officers: uniqBy(officers, "officer.name") })), source: "company", searchType: "name" });
            } else if (company.key === "bvd") {
                company = { ...company, isLoading: true, isReportLoading: true };
                let requestBody = {};
                let data = null;
                if (company?.api_all_data?.BVDID) {
                    let url = `/api/v1/company/bvd/details`;
                    requestBody = {
                        bvd_id: company?.api_all_data?.BVDID,
                        request_id: company.api_all_data.query_id || this.getSelectedToolQuery.query_id,
                        card_type: "company",
                        doc_id: company.api_all_data.doc_id,
                    };
                    data = await osintAxios.post(url, requestBody);
                }
                company = {
                    ...company,
                    api_all_data: {
                        ...company.api_all_data,
                        ...data?.data?.data[0],
                    },
                    [`fetched${company.api_call_type}`]: true,
                    [`${company.api_call_type}Expanded`]: !company[`${company.api_call_type}Expanded`],
                    isLoading: false,
                    isReportLoading: true,
                };
                this.$emit("searchResult", { data: [company], source: "company", searchType: "name" });
                // company.expanded = !company.expanded;
                this.$forceUpdate();
            } else if (company.key === "officer_bvd") {
                let requestBody = {};
                let data = null;
                if (company?.company_number) {
                    let url = `/api/v1/company/bvd/details`;
                    requestBody = {
                        request_id: company.api_all_data.query_id || this.getSelectedToolQuery.query_id,
                        id_company: company.api_all_data.CONTACTS_MEMBERSHIP_IdCompany,
                        id_director: company.api_all_data.directorId,
                        card_type: "officer",
                        doc_id: company.api_all_data.doc_id,
                    };
                    data = await osintAxios.post(url, requestBody);
                }

                company = {
                    ...company,
                    api_all_data: {
                        ...company.api_all_data,
                        ...data?.data?.data[0],
                    },
                    [`fetched${company.key}`]: true,
                    [`${company.api_call_type}Expanded`]: !company[`${company.api_call_type}Expanded`],
                    // isReportLoading: true,
                };
                this.$emit("searchResult", { data: [company], source: "company", searchType: "name" });
                // company.expanded = !company.expanded;
                this.$forceUpdate();
            }

            let detailsExpanded = true;
            if (company.detailsExpanded === false) detailsExpanded = false;
            if (detailsExpanded) {
                this.isComparisonModeOn = false;
                this.companyDetails = {...this.companyDetails, ...company};
                if (panelsDetails) {
                    this.companyDetails.expandedPanel = this.isAllPanelsExpanded(panelsDetails);
                }
            } else {
               
                this.isComparisonModeOn = true;
               
              
                if (handleExpandAllFlag && !(company.key === "officer_companyWatch" && company.api_call_type === "CurrentAppointments"))
                    this.handleExpandAllPanel({
                        details: company,
                        key: company.key,
                        value: true,
                    });
                else {
                    if (!(company.key === "officer_companyWatch" && company.api_call_type === "CurrentAppointments")) this.updateComparisonReferences(company);
                }
                
            }

            this.$forceUpdate();
        },

        isAllPanelsExpanded(panelsDetails) {
            return Object.entries(panelsDetails).filter(x => x[1]).every(x => !!this.companyDetails[`${x[0]}Expanded`])
        }, 

        async fetchReport(data) {
            let company = data.details;
            const bvd_id = data.id;
            if (!company.report_url) {
                company = {...company, isReportLoading: true};
                this.companyDetails = company;
                this.$forceUpdate();
                const report_url = `/api/v1/company/bvd/report`;
                const requestBody = {
                    bvd_id,
                    // company.company_number,
                    request_id: company?.api_all_data?.query_id,
                    card_type: company?.key === "bvd" ? "company" : "officer",
                    id_company: company.api_all_data.CONTACTS_MEMBERSHIP_IdCompany,
                    id_director: company.api_all_data.directorId,
                };
                try {
                    const resp = await osintAxios.post(report_url, requestBody);
                    if (resp.data.status) {
                        const pdf_url = `https://neotas-bvd-report-pdf.s3.amazonaws.com/${resp.data.filename}`;
                        company = {...company, report_url: pdf_url, isReportLoading: false};
                        this.companyDetails = company;
                    }
                } catch (error) {
                    this.$toast.error(this.$t('components.tools.company_identifier.error_loading_full_report'));
                    company = {...company, isReportLoading: false};
                    this.companyDetails = company;
                }
                // this.showMoreInfo = true;
                // company.expanded = !company.expanded;
                this.companyDetails = company;
                this.$forceUpdate();
            }
        },

        clearFilters() {
            this.companyType = "";
            this.page_number = 1;
            this.currentQuery = -1;
            this.status = "";
            this.statusFilter = null;
            this.companyTypeFilter = null;
            this.sourceTypeFilter = null;
            this.sourceType = "";
            this.jurisdictionType = "";
            this.filterJurisdiction = null
            this.dateRange = [];
            this.order_by = null;
            // this.totalCount = 0;
            // this.isAllRunQueries = false;
            this.searchQuery = "";
            this.setDefaultFilters()

            this.handleApplyFilters();
            this.setCardStatusCounts(true);
            this.appliedFilterCount = 0;
            // this.handleCloseMoreInfo();
        },
        open_company_house() {
            if (this.registry.firstName && this.registry.lastName) {
                window.open(`https://find-and-update.company-information.service.gov.uk/search/officers?q=${this.registry.firstName} ${this.registry.lastName}`, "_blank", "noopener");
            }
            if (this.registry.nickname && this.registry.lastName) {
                window.open(`https://find-and-update.company-information.service.gov.uk/search/officers?q=${this.registry.nickname} ${this.registry.lastName}`, "_blank", "noopener");
            }
            if (this.registry.nickname && this.registry.lastName && this.registry.middleName) {
                window.open(`https://find-and-update.company-information.service.gov.uk/search/officers?q=${this.registry.nickname} ${this.registry.middleName} ${this.registry.lastName}`, "_blank", "noopener");
            }
            if (this.registry.firstName && this.registry.lastName && this.registry.middleName) {
                window.open(`https://find-and-update.company-information.service.gov.uk/search/officers?q=${this.registry.firstName} ${this.registry.middleName} ${this.registry.lastName}`, "_blank", "noopener");
            }
        },
        open_corporates() {
            if (this.registry.firstName && this.registry.lastName) {
                window.open(`https://opencorporates.com/officers?q=${this.registry.firstName}+${this.registry.lastName}`, "_blank", "noopener");
            }
            if (this.registry.nickname && this.registry.lastName) {
                window.open(`https://opencorporates.com/officers?q=${this.registry.nickname}+${this.registry.lastName}`, "_blank", "noopener");
            }
        },
        open_company_check() {
            if (this.registry.firstName && this.registry.lastName) {
                window.open(`https://companycheck.co.uk/search?type=director-uk&term=${this.registry.firstName}+${this.registry.lastName}`, "_blank", "noopener");
            }
            if (this.registry.nickname && this.registry.lastName) {
                window.open(`https://companycheck.co.uk/search?type=director-uk&term=${this.registry.nickname}+${this.registry.lastName}`, "_blank", "noopener");
            }
        },
        open_occrp() {
            if (this.registry.firstName && this.registry.lastName) {
                window.open(`https://data.occrp.org/search?limit=30&q="${this.registry.firstName}+${this.registry.lastName}"`, "_blank", "noopener");
            }
            if (this.registry.firstName && this.registry.lastName) {
                window.open(`https://data.occrp.org/search?limit=30&q="${this.registry.lastName}+${this.registry.firstName}"`, "_blank", "noopener");
            }
            if (this.registry.nickname && this.registry.lastName) {
                window.open(`https://data.occrp.org/search?limit=30&q="${this.registry.nickname}+${this.registry.lastName}"`, "_blank", "noopener");
            }
            if (this.registry.nickname && this.registry.lastName) {
                window.open(`https://data.occrp.org/search?limit=30&q="${this.registry.lastName}+${this.registry.nickname}"`, "_blank", "noopener");
            }
            if (this.registry.nickname && this.registry.lastName && this.registry.middleName) {
                window.open(`https://data.occrp.org/search?limit=30&q="${this.registry.nickname}+${this.registry.middleName}+${this.registry.lastName}"`, "_blank", "noopener");
                window.open(`https://data.occrp.org/search?limit=30&q="${this.registry.nickname}+${this.registry.middleName.substring(0, 1)}+${this.registry.lastName}"`, "_blank", "noopener");
            }
            if (this.registry.firstName && this.registry.lastName && this.registry.middleName) {
                window.open(`https://data.occrp.org/search?limit=30&q="${this.registry.firstName}+${this.registry.middleName}+${this.registry.lastName}"`, "_blank", "noopener");
                window.open(`https://data.occrp.org/search?limit=30&q="${this.registry.firstName}+${this.registry.middleName.substring(0, 1)}+${this.registry.lastName}"`, "_blank", "noopener");
            }
        },
        open_icij() {
            if (this.registry.firstName && this.registry.lastName) {
                window.open(`https://offshoreleaks.icij.org/search?q="${this.registry.firstName}+${this.registry.lastName}"`, "_blank", "noopener");
            }
            if (this.registry.firstName && this.registry.lastName) {
                window.open(`https://offshoreleaks.icij.org/search?q="${this.registry.lastName}+${this.registry.firstName}"`, "_blank", "noopener");
            }
            if (this.registry.nickname && this.registry.lastName) {
                window.open(`https://offshoreleaks.icij.org/search?q="${this.registry.nickname}+${this.registry.lastName}"`, "_blank", "noopener");
            }
            if (this.registry.nickname && this.registry.lastName) {
                window.open(`https://offshoreleaks.icij.org/search?q="${this.registry.lastName}+${this.registry.nickname}"`, "_blank", "noopener");
            }
            if (this.registry.nickname && this.registry.lastName && this.registry.middleName) {
                window.open(`https://offshoreleaks.icij.org/search?q="${this.registry.nickname}+${this.registry.middleName}+${this.registry.lastName}"`, "_blank", "noopener");
                window.open(`https://offshoreleaks.icij.org/search?q="${this.registry.nickname}+${this.registry.middleName.substring(0, 1)}+${this.registry.lastName}"`, "_blank", "noopener");
            }
            if (this.registry.firstName && this.registry.lastName && this.registry.middleName) {
                window.open(`https://offshoreleaks.icij.org/search?q="${this.registry.firstName}+${this.registry.middleName}+${this.registry.lastName}"`, "_blank", "noopener");
                window.open(`https://offshoreleaks.icij.org/search?q="${this.registry.firstName}+${this.registry.middleName.substring(0, 1)}+${this.registry.lastName}"`, "_blank", "noopener");
            }
        },
        open_ownership() {
            if (this.registry.firstName && this.registry.lastName) {
                window.open(`https://register.openownership.org/search?q="${this.registry.firstName}+${this.registry.lastName}"`, "_blank", "noopener");
            }
            if (this.registry.firstName && this.registry.lastName) {
                window.open(`https://register.openownership.org/search?q="${this.registry.lastName}+${this.registry.firstName}"`, "_blank", "noopener");
            }
            if (this.registry.nickname && this.registry.lastName) {
                window.open(`https://register.openownership.org/search?q="${this.registry.nickname}+${this.registry.lastName}"`, "_blank", "noopener");
            }
            if (this.registry.nickname && this.registry.lastName) {
                window.open(`https://register.openownership.org/search?q="${this.registry.lastName}+${this.registry.nickname}"`, "_blank", "noopener");
            }
            if (this.registry.nickname && this.registry.lastName && this.registry.middleName) {
                window.open(`https://register.openownership.org/search?q="${this.registry.nickname}+${this.registry.middleName}+${this.registry.lastName}"`, "_blank", "noopener");
                window.open(`https://register.openownership.org/search?q="${this.registry.nickname}+${this.registry.middleName.substring(0, 1)}+${this.registry.lastName}"`, "_blank", "noopener");
            }
            if (this.registry.firstName && this.registry.lastName && this.registry.middleName) {
                window.open(`https://register.openownership.org/search?q="${this.registry.firstName}+${this.registry.middleName}+${this.registry.lastName}"`, "_blank", "noopener");
                window.open(`https://register.openownership.org/search?q="${this.registry.firstName}+${this.registry.middleName.substring(0, 1)}+${this.registry.lastName}"`, "_blank", "noopener");
            }
        },
        open_sec_gov() {
            if (this.registry.firstName && this.registry.lastName) {
                window.open(`https://www.sec.gov/edgar/search/#/q="${this.registry.firstName}+${this.registry.lastName}"&dateRange=all`, "_blank", "noopener");
            }
            if (this.registry.firstName && this.registry.lastName) {
                window.open(`https://www.sec.gov/edgar/search/#/q="${this.registry.lastName}+${this.registry.firstName}"&dateRange=all`, "_blank", "noopener");
            }
            if (this.registry.nickname && this.registry.lastName) {
                window.open(`https://www.sec.gov/edgar/search/#/q="${this.registry.nickname}+${this.registry.lastName}"&dateRange=all`, "_blank", "noopener");
            }
            if (this.registry.nickname && this.registry.lastName) {
                window.open(`https://www.sec.gov/edgar/search/#/q="${this.registry.lastName}+${this.registry.nickname}"&dateRange=all`, "_blank", "noopener");
            }
            if (this.registry.nickname && this.registry.lastName && this.registry.middleName) {
                window.open(`https://www.sec.gov/edgar/search/#/q="${this.registry.nickname}+${this.registry.middleName}+${this.registry.lastName}"&dateRange=all`, "_blank", "noopener");
                window.open(`https://www.sec.gov/edgar/search/#/q="${this.registry.nickname}+${this.registry.middleName.substring(0, 1)}+${this.registry.lastName}"&dateRange=all`, "_blank", "noopener");
            }
            if (this.registry.firstName && this.registry.lastName && this.registry.middleName) {
                window.open(`https://www.sec.gov/edgar/search/#/q="${this.registry.firstName}+${this.registry.middleName}+${this.registry.lastName}"&dateRange=all`, "_blank", "noopener");
                window.open(`https://www.sec.gov/edgar/search/#/q="${this.registry.firstName}+${this.registry.middleName.substring(0, 1)}+${this.registry.lastName}"&dateRange=all`, "_blank", "noopener");
            }
        },
        open_gazettes() {
            if (this.registry.firstName && this.registry.lastName) {
                window.open(`http://opengazettes.com/search?q=${this.registry.firstName}+${this.registry.lastName}`, "_blank", "noopener");
            }
            if (this.registry.nickname && this.registry.lastName) {
                window.open(`http://opengazettes.com/search?q=${this.registry.nickname}+${this.registry.lastName}`, "_blank", "noopener");
            }
            if (this.registry.nickname && this.registry.lastName && this.registry.middleName) {
                window.open(`http://opengazettes.com/search?q=${this.registry.nickname}+${this.registry.middleName}+${this.registry.lastName}`, "_blank", "noopener");
            }
            if (this.registry.firstName && this.registry.lastName && this.registry.middleName) {
                window.open(`http://opengazettes.com/search?q=${this.registry.firstName}+${this.registry.middleName}+${this.registry.lastName}`, "_blank", "noopener");
            }
        },
        /**
         * When tab is monitoring
         * Fetch monitoring results
         * @param {array} sources: []
         * @param {string} type: 'officer'/'company'/'address'
         */
        async monitoringSearch(sources, type) {
            this.sources = sources;
            this.showResult = true;
            this.showSearch = false;
            this.startLoader("companySearch");
            this.searchedClicked = true;
            if (this.latestVersionResultsCount == this.domainCompanyDetailsSearch.length) {
                this.apiCallPages = 1;
                this.page_number = 1;
                this.domainCompanyDetailsSearch = [];
            }
            let offset = 0;
            //To navigate to a different URL, according to the selected query
            this.redirectTo();
            const monitoringFilters = {
                startDate: this.dateRange[0],
                endDate: this.dateRange[1],
                dataType: this.selectedDataType.value,
                sort_by: this.order_by?.value || "",
                sort_order: this.order_by?.value? "desc" : ""
            }
            let values = await monitoringSearchData(this.getNeoCaseId, sources, this.$route.query.check_name, monitoringFilters, this.getSelectedToolQuery, offset);
            this.latestVersionResultsCount = values.totalResults;
            // opencorporates
            let open_corporates,
                clarifiedBy,
                companyWatch,
                bvd = [];
            if (type === "company") {
                open_corporates = this.getMappingValue(
                    values?.values?.filter((val) => val.doc_source === "opencorporates"),
                    "openCorporates",
                    CORPORATE_TOOL_MAPPING
                );
                clarifiedBy = this.getMappingValue(
                    values?.values?.filter((val) => val.doc_source === "clarifiedby"),
                    "clarifiedBy",
                    CORPORATE_TOOL_MAPPING
                );
                companyWatch = this.getMappingValue(
                    values?.values?.filter((val) => val.doc_source === "companywatch"),
                    "companyWatch",
                    CORPORATE_TOOL_MAPPING
                );
                bvd = this.getMappingValue(
                    values?.values?.filter((val) => val.doc_source === "bvd"),
                    "bvd",
                    CORPORATE_TOOL_MAPPING
                );
            } else {
                open_corporates = this.getMappingValue(
                    values?.values?.filter((val) => val.doc_source === "opencorporates"),
                    "officer",
                    CORPORATE_TOOL_MAPPING,
                    "openCorporates"
                );
                clarifiedBy = this.getMappingValue(
                    values?.values?.filter((val) => val.doc_source === "clarifiedby"),
                    "officer_clarifiedBy",
                    CORPORATE_TOOL_MAPPING,
                    "clarifiedBy"
                );
                companyWatch = this.getMappingValue(
                    values?.values?.filter((val) => val.doc_source === "companywatch"),
                    "officer_companyWatch",
                    CORPORATE_TOOL_MAPPING,
                    "companyWatch"
                );
                let results = [];

                values?.values
                    ?.filter((val) => val.doc_source === "bvd")
                    .forEach((officer) => {
                        let start = results.length;
                        results.push(officer);
                        for (let i = start; i < results.length; i++)
                            results[i] = {
                                ...results[i],
                                officerName: officer.CONTACTS_HEADER_FULLNAME,
                                directorId: officer.CONTACTS_HEADER_IdDirector,
                                country: officer.CONTACTS_HEADER_HomeCountry,
                                doc_source: officer.doc_source,
                                monitoring_id: officer.monitoring_id,
                                monitoring_result_status: officer.monitoring_result_status,
                                changes_viewed: officer.changes_viewed,
                                // monitoring_status: officer.monitoring_status,
                                monitoringDate: officer.monitoringDate,
                                // monitoring_result_flag: officer.
                                // mon_src._source.data.monitoring_result_status = mon_src._source.status;
                                // mon_src._source.data.monitoring_status = mon_src.monitoring_status;
                            };
                    });

                results = uniqBy(
                    results.map((item) => ({
                        ...item,
                        key: "officer_bvd",
                    })),
                    "CONTACTS_MEMBERSHIP_IdCompany"
                );
                bvd = this.getMappingValue(results, "officer_bvd", CORPORATE_TOOL_MAPPING, "bvd");
            }
            // const monitoringDocIds = open_corporates.map((res)=>res.api_all_data.doc_id)
            // this.domainCompanyDetailsSearch = this.domainCompanyDetailsSearch.filter((res)=>!monitoringDocIds.includes(res.api_all_data.doc_id))
            this.domainCompanyDetailsSearch = [...open_corporates, ...clarifiedBy, ...bvd, ...companyWatch];
            this.domainCompanyDetailsSearch = this.domainCompanyDetailsSearch.map((ele, index) => ({...ele, current_index: index}));
            this.cardStatusResults = this.domainCompanyDetailsSearch
            await this.getAllCardsDetails()
            this.setCardStatusCounts();
            this.$emit("updateQueryTotal", { checkName: this.$route.query.check_name })
            this.totalCount = this.domainCompanyDetailsSearch?.length
            this.csvData.company = this.convertToCSV(this.domainCompanyDetailsSearch);
            this.csvFields = ["company_number", "company_name", "status", "address", "company_type", "jurisdiction", "incorporation_date"];
            this.resetLoader("companySearch");
            this.$emit("getInitialQueryCount");
        },
        checkConfig(sourcesResponse) {
            let message = []
            sourcesResponse.forEach((source)=>{
                if (source?.data?.status_code == 2004) {
                    message.push(source?.data?.message)
                }
            })
            return message
        },
        async search(refreshFlag, filtersSection, fromSelectOption = false) {
            this.selectedJurisdiction = false;
            console.log(fromSelectOption)
            if(this.order_by === null && !fromSelectOption)
                this.tabsStatus.selected = 'all';
            this.page_number = 1
            this.items_count = 10
            this.timeline = [];

            this.updateMonitoringCascadingTimeline({
                timeline: this.timeline,
                meta_data: null,
            });
            this.setCardStatusCounts()
            if (!filtersSection) {
                this.setDefaultFilters()
                this.showFiltersPanel = false
            }
            this.searchClicked = true;
            if (this.apiCallPages == 1) this.page_number = 1;
            if (!this.openCorpSourceAuth) {
                this.openCorporatesCheck = false;
            }
            if (!this.dbCorpRecord && !this.dbResellerCorpRecord) {
                this.dnbCheck = false;
            }
            if (!this.clarifiedBySourceAuth) {
                this.clarifiedByCheck = false;
            }
            if (!this.companyWatchSourceAuth) {
                this.companyWatchCheck = false;
            }
            if (!this.bvdSourceAuth) {
                this.bvdCheck = false;
            }
            this.isSavedLoading = {
                loading: false,
                loadingCardIndex: null,
            };
            this.isOldVersionSelected = false;
           
            // let list = [];
            let start = this.entityCount - 1;
            if (this.currentQuery >= 0) start = this.currentQuery;
            for (let i = start; i >= 0; i--) {
                // this.showResult = false;
                this.companyType = "";
                this.status = "";
                this.sourceType = "";
                this.jurisdictionType = "";
                this.searchQuery = "";
                this.triggerRoute = false;
                this.totalCount = 0;
                if (this.apiCallPages == 1) this.domainCompanyDetailsSearch = [];
                const headers = {
                    "x-tool-name": this.$route.query.check_name,
                    "x-visited": true,
                    "x-refresh": refreshFlag || false,
                    "x-entity-id": this.$route.query.entityId,
                    ...this.autorun?.headers,
                };

                if ((i === 0 && this.searchKeyword) || this.queries[i - 1]?.company?.value || this.isAllRunQueries) {
                    // openCorporatesCheck: false,
                    // clarifiedByCheck: false,
                    // companyWatchCheck: false,
                    // bvdCheck: false,
                    // if(this.searchKeyword !==)
                    if(this.autorun){
                        if([CORPORATE_RECORDS_CHECK_ID].includes(this.sourceId)){
                           this.bvdCheck = true 
                        }
                        if([DNB_CHECK_ID].includes(this.sourceId)) {
                            this.dnbCheck = true 
                            // sources.push("db");
                        }
                        if (this.selectedQuery?.query.sources[0] === "openCorporates") {
                            this.openCorporatesCheck = true 
                            // sources.push("openCorporates");
                        }
                    }
                    else{
                        if (i === 0 && !this.openCorporatesCheck && !this.clarifiedByCheck && !this.companyWatchCheck && !this.bvdCheck && !this.dnbCheck && !this.isAllRunQueries) {
                            this.showResult = false
                            this.$toast.error(ErrorMessages.RequiredSources);
                            return;
                        }
                    }
                    if (i === 0 && this.dnbCheck && this.dbJurisdiction === null && this.duns === "" && (this.registrationNumber != "" || this.dbaddress != "" || this.postCode != "" || this.locality != "" || this.region != "" || this.phone != "" || this.email != "")) {
                        this.selectedJurisdiction = true;
                        return;
                    }

                    this.startLoader("companySearch");
                    this.csvData = {
                        company: [],
                    };
                    this.csvFields = [];
                    let openCorporates, clarifiedBy, companyWatch, bvd;
                    let query = {q: i === 0 ? this.searchKeyword : this.queries[i - 1].company.value, type: "company", sources: []};
                    let sources = [];
                    if (this.dnbCheck) {
                        sources.push("db");
                    }
                    if (this.openCorporatesCheck) {
                        sources.push("openCorporates");
                    }
                    if (this.clarifiedByCheck) {
                        sources.push("clarifiedBy");
                    }
                    if (this.companyWatchCheck) {
                        sources.push("companyWatch");
                    }
                    if (this.bvdCheck) {
                        sources.push("bvd");
                    }
                    if (this.jurisdiction?.value) {
                        query.code = this.jurisdiction?.value;
                    }
                    
                    if (this.searchMode?.value?.value && this.companyWatchCheck) {
                        //let search_mode_find =  this.searchMode.value.value);
                        query.mode = this.searchMode.value.value;
                    }
                    // request_id
                    query.sources = sources.join(",");
                    
                    let data = "";
                    if (this.companyWatchCheck) {
                        data = {
                            name: i === 0 ? this.searchKeyword : this.queries[i - 1].company.value,
                            mode: this.searchMode?.value?.value,
                            code: i === 0 ? this.jurisdiction?.value : this.queries[i - 1]?.jurisdiction?.value,
                            sources: sources.map((el) => el.toLowerCase()).sort((a, b) => a.localeCompare(b)),
                            ...this.prebuiltQueryPayload,
                        };
                    } else {
                        data = {
                            name: i === 0 ? this.searchKeyword : this.queries[i - 1].company.value,
                            code: i === 0 ? this.jurisdiction?.value : this.queries[i - 1]?.jurisdiction?.value,
                            sources: sources.map((el) => el.toLowerCase()).sort((a, b) => a.localeCompare(b)),
                            ...this.prebuiltQueryPayload,
                        };
                        if(this.bvdCheck && this.fieldType.value === 'officer') {
                            if(this.getDob()) {
                                data.dobfrom = this.getDob();
                            }
                            if(this.selectedNationalityFilter) {
                                data.nationality =  [this.selectedNationalityFilter?.label]
                            }
                            if(this.selectedCountryFilter) {
                                data.countryofresidence = [this.selectedCountryFilter?.label]
                            }
                        }
                        if (this.bvdCheck && this.fieldType.value === 'company') {
                            if(this.selectedJurisdictionFilter) {
                                // data.city = this.selectedJurisdictionFilter?.label || "";
                                data.country =  this.selectedJurisdictionFilter?.value || "";
                            }
                        }
                    }
                    if (this.jurisdiction?.value && this.dbJurisdiction?.country_code && this.jurisdiction?.value.toLowerCase() !== this.dbJurisdiction?.country_code.toLowerCase()) {
                        let index = sources.indexOf("db");
                        if (index > -1) {
                            sources.splice(index, 1);
                        }
                    }
                    // data = {
                    //     name: i === 0 ? this.searchKeyword : this.queries[i - 1].company.value,
                    //     sources: sources.map((el) => el.toLowerCase()).sort((a, b) => a.localeCompare(b)),
                    // };
                    if (this.companyWatchCheck) {
                        data.mode = this.searchMode?.value?.value;
                    }
                    if (this.openCorporatesCheck) {
                        data.code = i === 0 ? this.jurisdiction?.value || this.dbJurisdiction?.country_code.toLowerCase() : this.queries[i - 1]?.jurisdiction?.value || this.queries[i - 1]?.dbJurisdiction?.country_code.toLowerCase();
                    }
                    if (this.dnbCheck && !this.openCorporatesCheck) {
                        data.code = i === 0 ? this.dbJurisdiction?.country_code.toLowerCase() : this.queries[i - 1]?.dbJurisdiction?.country_code.toLowerCase();
                    }

                    if ((this.dnbCheck && this.openCorporatesCheck && this.jurisdiction?.value?.toLowerCase() === this.dbJurisdiction?.country_code?.toLowerCase()) || (this.dnbCheck && this.openCorporatesCheck && !this.jurisdiction?.value) || (this.dnbCheck && !this.openCorporatesCheck)) {
                        if (this.registrationNumber != "") {
                            data.registration_number = this.registrationNumber;
                        }
                        if (this.dbaddress != "") {
                            data.street_address_line1 = this.dbaddress;
                        }
                        if (this.postCode != "") {
                            data.postal_code = this.postCode;
                        }
                        if (this.locality != "") {
                            data.address_locality = this.locality;
                        }
                        if (this.region != "") {
                            data.address_region = this.region;
                        }
                        if (this.phone != "") {
                            data.telephone_number = this.phone;
                        }
                        if (this.duns != "") {
                            data.duns = this.duns;
                        }
                        if (this.email != "") {
                            data.email = this.email;
                        }
                    }
                    let dbData = "";
                    let response = "";
                    
                    Object.assign(data, this.prebuiltQueryPayload);
                    if(this.dnbCheck){
                        data = await this.getQueryPayload(data, "db");
                    }
                   
                    const {data: sourcesCall} = await mainAxios.post("/service/company/search/sources", data, { headers: {
                        ...headers,
                        "x-wlp-reference": process.env.VUE_APP_BACKEND_URL,
                        "x-status": 'RUNNING',
                        "x-case-id": this.getNeoCaseId,
                    },});
                    if (this.dnbCheck && this.openCorporatesCheck && this.jurisdiction?.value && this.dbJurisdiction?.country_code && this.jurisdiction?.value.toLowerCase() !== this.dbJurisdiction?.country_code.toLowerCase()) {
                        dbData = {
                            name: i === 0 ? this.searchKeyword : this.queries[i - 1].company.value,
                            sources: ["db"],
                            code: i === 0 ? this.dbJurisdiction?.country_code.toLowerCase() : this.queries[i - 1]?.dbJurisdiction?.country_code.toLowerCase(),
                            ...this.prebuiltQueryPayload,
                        };
                        if (this.registrationNumber != "") {
                            dbData.registration_number = this.registrationNumber;
                        }
                        if (this.dbaddress != "") {
                            dbData.street_address_line1 = this.dbaddress;
                        }
                        if (this.postCode != "") {
                            dbData.postal_code = this.postCode;
                        }
                        if (this.locality != "") {
                            dbData.address_locality = this.locality;
                        }
                        if (this.region != "") {
                            dbData.address_region = this.region;
                        }
                        if (this.phone != "") {
                            dbData.telephone_number = this.phone;
                        }
                        if (this.duns != "") {
                            dbData.duns = this.duns;
                        }
                        if (this.email != "") {
                            dbData.email = this.email;
                        }
                        response = await mainAxios.post("/company/search/sources", dbData, { headers: {
                            ...headers,
                            "x-wlp-reference": process.env.VUE_APP_BACKEND_URL,
                            "x-status": 'RUNNING',
                            "x-case-id": this.getNeoCaseId,
                        },});
                    }
                    const queryExists = this.searchedQueries.some((res)=>res._id==sourcesCall.request_id)
                    if (!queryExists) {
                        this.monitoringActive = false
                    }
                    if (this.monitoringActive && !this.isAllRunQueries) {
                        if (!sources.includes("db")) {
                            await this.monitoringSearch(sources, "company");
                            return;
                        } else {
                            if (sources?.length > 1)
                                await this.monitoringSearch(sources, "company");
                        }
                    }

                    this.request_id = sourcesCall.request_id;
                    this.redirectTo();
                    if (this.openCorporatesCheck && !this.monitoringActive) {
                        let requestBody = {
                            name: i === 0 ? this.searchKeyword : this.queries[i - 1].company.value,
                            code: i === 0 ? this.jurisdiction?.value : this.queries[i - 1]?.jurisdiction?.value,
                            request_id: sourcesCall.request_id,
                            ...this.prebuiltQueryPayload,
                        };
                        if (this.nerFilters) requestBody.output_filters = this.nerFilters;
                        openCorporates = mainAxios.post("/service/company/search", requestBody, {
                            headers: {
                                ...headers,
                                "x-wlp-reference": process.env.VUE_APP_BACKEND_URL,
                                "x-status": 'RUNNING',
                                "x-case-id": this.getNeoCaseId,
                            },
                        });
                    }
                    if (this.clarifiedByCheck && !this.monitoringActive) {
                        const requestBody = {
                            name: i === 0 ? this.searchKeyword : this.queries[i - 1].company.value,
                            type: "organisations",
                            request_id: sourcesCall.request_id,
                            ...this.prebuiltQueryPayload,
                        };
                        if (this.nerFilters) requestBody.output_filters = this.nerFilters;
                        clarifiedBy = osintAxios.post("/api/v1/company/clarifiedby/search", requestBody, {
                            headers,
                        });
                    }
                    if (this.companyWatchCheck && !this.monitoringActive) {
                        const requestBody = {
                            name: i === 0 ? this.searchKeyword : this.queries[i - 1].company.value,
                            code: i === 0 ? this.jurisdiction?.value : this.queries[i - 1]?.jurisdiction?.value,
                            mode: this.searchMode?.value?.value,
                            request_id: sourcesCall.request_id,
                            ...this.prebuiltQueryPayload,
                        };
                        if (this.nerFilters) requestBody.output_filters = this.nerFilters;
                        companyWatch = osintAxios.post("/api/v1/company/company-watch/search", requestBody, {
                            headers,
                        });
                    }
                    if (this.bvdCheck && !this.monitoringActive) {
                        let requestBody = {
                            name: i === 0 ? this.searchKeyword : this.queries[i - 1].company.value,
                            request_id: sourcesCall.request_id,
                            ...this.prebuiltQueryPayload,
                        };
                        if(this.fieldType.value === 'company') {
                            if(this.selectedJurisdictionFilter) {
                                // requestBody.city = this.selectedJurisdictionFilter?.label || "";
                                requestBody.country =  this.selectedJurisdictionFilter?.value || "";
                            }
                        }
                        if (this.nerFilters) requestBody.output_filters = this.nerFilters;

                        const query_payload = await this.getQueryPayload(requestBody, "bvd");
                        bvd = osintAxios.post("/api/v1/company/bvd/search", query_payload, {
                            headers,
                        });
                    }
                    let db
                    if (this.dnbCheck) {
                        let requestBody = {
                            name: i === 0 ? this.searchKeyword : this.queries[i - 1].company.value,
                            code: i === 0 ? this.dbJurisdiction?.country_code.toLowerCase() : this.queries[i - 1]?.dbJurisdiction?.country_code.toLowerCase(),
                            request_id: response?.data?.request_id ? response.data.request_id : sourcesCall.request_id,
                            ...this.prebuiltQueryPayload,
                        };
                        if (this.registrationNumber != "") {
                            requestBody.registration_number = this.registrationNumber;
                        }
                        if (this.address != "") {
                            requestBody.street_address_line1 = this.dbaddress;
                        }
                        if (this.postCode != "") {
                            requestBody.postal_code = this.postCode;
                        }
                        if (this.locality != "") {
                            requestBody.address_locality = this.locality;
                        }
                        if (this.region != "") {
                            requestBody.address_region = this.region;
                        }
                        if (this.phone != "") {
                            requestBody.telephone_number = this.phone;
                        }
                        if (this.duns != "") {
                            requestBody.duns = this.duns;
                        }
                        if (this.email != "") {
                            requestBody.email = this.email;
                        }

                        const query_payload = await this.getQueryPayload(requestBody, "db");
                        if (this.dbJurisdiction?.country_code || this.duns) {
                            db = osintAxios.post("/api/v1/db/identity_resolution", query_payload, {
                                headers,
                            });
                            this.typehead = false;
                        } else {
                            db = mainAxios.post("/service/db/type_head", query_payload, {
                                headers: {
                                    "x-tool-name": this.$route.query.check_name,
                                    "x-visited": true,
                                    "x-refresh": refreshFlag || false,
                                    "x-entity-id": this.$route.query.entityId,
                                    "x-wlp-reference": `${process.env.VUE_APP_BACKEND_URL}`,
                                    "x-status": 'RUNNING',
                                    "x-case-id": this.getNeoCaseId,
                                    ...this.autorun?.headers,
                                    
                                },
                            });
                            this.typehead = true;
                        }
                    }

                    this.$emit("searched", {data: {company_name: i === 0 ? this.searchKeyword : this.queries[i - 1].company.value}, source: "company"});
                    await this.setSearchedUser(i === 0 ? this.searchKeyword : this.queries[i - 1].company.value, "company_name");
                    // await this.getAllCardsDetails()

                    if ((openCorporates || clarifiedBy || companyWatch || bvd || db) && i === 0) {
                        if (this.apiCallPages === 1 && !(this.monitoringActive && !this.isAllRunQueries && sources?.length > 1 && sources.includes("db"))) 
                            this.domainCompanyDetailsSearch = [];
                        await Promise.allSettled([openCorporates, clarifiedBy, companyWatch, bvd, db])
                            .then(async (results) => {
                                let values = results.map((result) => result.value);
                                // let configMissing = this.checkConfig(values)
                                // if (configMissing.length>0) {
                                //     configMissing.forEach((mes)=>{
                                //         this.$toast.error(mes)
                                //     })
                                //     return
                                // }
                                if (this.apiCallPages === 1 && !(this.monitoringActive && !this.isAllRunQueries && sources?.length > 1 && sources.includes("db"))) 
                                    this.domainCompanyDetailsSearch = [];

                                //OpenCorporates
                                if (values[0]?.data?.data?.length > 0) {
                                    this.totalCount = resolveResponseTotalCount(values[0]);
                                    // CORPORATE_TOOL_MAPPING
                                    const mappingValue = this.getMappingValue(values[0]?.data?.data, "openCorporates", CORPORATE_TOOL_MAPPING);
                                    this.domainCompanyDetailsSearch = [...this.domainCompanyDetailsSearch, ...mappingValue];
                                    this.showSearch = false;
                                    this.showResult = true;
                                }
                                this.openCorporateResults = values[0]?.data?.data?.length ?? 0;
                                this.totalOpenCorporateResults = resolveResponseTotalCount(values[0]);
                                this.sourcesCall = sourcesCall;
                                //ClarifiedBy
                                if (values[1]?.data?.data?.length > 0) {
                                    this.totalCount +=resolveResponseTotalCount(values[1])
                                    const mappingValue = this.getMappingValue(values[1]?.data?.data, "clarifiedBy", CORPORATE_TOOL_MAPPING);
                                    this.domainCompanyDetailsSearch = [...this.domainCompanyDetailsSearch, ...mappingValue];
                                    this.showSearch = false;
                                    this.showResult = true;
                                    // this.$emit("searchResult", { data: this.domainCompanyDetailsSearch, source: "company", searchType: "name" });
                                }
                                //companyWatch
                                if (values[2]?.data?.data?.length > 0) {
                                    this.totalCount += resolveResponseTotalCount(values[2])
                                    const mappingValue = this.getMappingValue(values[2]?.data?.data, "companyWatch", CORPORATE_TOOL_MAPPING);
                                    this.domainCompanyDetailsSearch = [...this.domainCompanyDetailsSearch, ...mappingValue];
                                    this.showSearch = false;
                                    this.showResult = true;
                                    // this.$emit("searchResult", { data: this.domainCompanyDetailsSearch, source: "company", searchType: "name" });
                                }

                                // bvd
                                const bvdData = values[3]?.data?.data;
                                if (bvdData?.length > 0) {
                                    this.totalCount += resolveResponseTotalCount(values[3])
                                    const mappingValue = this.getMappingValue(bvdData, "bvd", CORPORATE_TOOL_MAPPING);
                                    this.domainCompanyDetailsSearch = [...this.domainCompanyDetailsSearch, ...mappingValue];
                                    this.showSearch = false;
                                    this.showResult = true;
                                    // this.$emit("searchResult", { data: this.domainCompanyDetailsSearch, source: "company", searchType: "name" });
                                }
                                if (values[4]?.data?.data?.length > 0) {
                                    this.totalCount += resolveResponseTotalCount(values[4])
                                    if (this.typehead) {
                                        values[4]?.data?.data?.map((el) => {
                                            if (el.data.organization.dunsControlStatus.isOutOfBusiness) {
                                                el.data.organization.dunsControlStatus.isOutOfBusiness = "Inactive";
                                            } else el.data.organization.dunsControlStatus.isOutOfBusiness = "Active";
                                        });
                                    }
                                    const mappingValue = this.getMappingValue(values[4]?.data?.data, "db", CORPORATE_TOOL_MAPPING);
                                    this.domainCompanyDetailsSearch = [...this.domainCompanyDetailsSearch, ...mappingValue];
                                    this.showSearch = false;
                                    this.showResult = true;
                                    // this.$emit("searchResult", { data: this.domainCompanyDetailsSearch, source: "company", searchType: "name" });
                                }

                                // if ((!values[0]?.data?.data || values[0]?.data?.data?.length === 0) && (!values[1]?.data?.data || values[1]?.data?.data?.length === 0) && (!values[2]?.data?.data || values[2]?.data?.data?.length === 0) && (!values[3]?.data?.data || values[3]?.data?.data?.length === 0) && ((!values[4]?.data?.data || values[4]?.data?.data?.length === 0))) {
                                //     if (values[0]?.data?.message || values[1]?.data?.message || values[2]?.data?.message || values[3]?.data?.message || values[4]?.data?.message) this.$toast.error(values[0]?.data?.message || values[1]?.data?.message || values[2]?.data?.message || values[3]?.data?.message || values[4]?.data?.message);
                                //     else this.$toast.error("No data found");
                                // }
                                if ((!results[0]?.status === "rejected" && values[0] && (!values[0]?.data?.data || values[0]?.data?.data?.length === 0)) && (!results[1]?.status === "rejected" && values[1] && (!values[1]?.data?.data || values[1]?.data?.data?.length === 0)) && (!results[2]?.status === "rejected" && values[2] && (!values[2]?.data?.data || values[2]?.data?.data?.length === 0)) && (!results[3]?.status === "rejected" && values[3] && (!values[3]?.data?.data || values[3]?.data?.data?.length === 0)) && (!results[4]?.status === "rejected" && values[4] && (!values[4]?.data?.data || values[4]?.data?.data?.length === 0))) {
                                    if (values[0]?.data?.message || values[1]?.data?.message || values[2]?.data?.message || values[3]?.data?.detail || values[4]?.data?.message) this.$toast.error(values[0]?.data?.message || values[1]?.data?.message || values[2]?.data?.message || values[3]?.data?.message || values[4]?.data?.message);
                                    else this.$toast.error(this.$t('components.tools.company_identifier.no_data_found'));
                                }

                                // if ((!values[0]?.data?.data || values[0]?.data?.data?.length === 0) && (!values[1]?.data?.data || values[1]?.data?.data?.length === 0) && (!values[2]?.data?.data || values[2]?.data?.data?.length === 0) && (!values[3]?.data?.data || values[3]?.data?.data?.length === 0) && (!values[4]?.data?.data || values[4]?.data?.data?.length === 0)) {
                                //     if (values[0]?.data?.message || values[1]?.data?.message || values[2]?.data?.message || values[3]?.data?.message || values[4]?.data?.message) this.$toast.error(values[0]?.data?.message || values[1]?.data?.message || values[2]?.data?.message || values[3]?.data?.message || values[4]?.data?.message);
                                //     else this.$toast.error("No data found");
                                // 
                                if (results[0]?.status === "rejected" || values[0]?.status === 500) {
                                    this.showSearch = false;
                                    this.showResult = true;
                                    this.$toast.error(this.$t('components.tools.company_identifier.opencorporates_something_went_wrong_please_try_again'));
                                }
                                if (results[1]?.status === "rejected" || values[1]?.status === 500) {
                                    this.showSearch = false;
                                    this.showResult = true;
                                    this.$toast.error(this.$t('components.tools.company_identifier.clarifiedby_something_went_wrong_please_try_again'));
                                }
                                if (results[2]?.status === "rejected" || values[2]?.status === 500) {
                                    this.showSearch = false;
                                    this.showResult = true;
                                    this.$toast.error(this.$t('components.tools.company_identifier.companywatch_something_went_wrong_please_try_again'));
                                }
                                if (results[3]?.status === "rejected" || values[3]?.status === 500) {
                                    this.showSearch = false;
                                    this.showResult = true;
                                    this.$toast.error(this.$t('components.tools.company_identifier.bvd_something_went_wrong_please_try_again'));
                                    // }
                                }
                                if (results[4]?.status === "rejected" || values[4]?.status === 500) {
                                    this.showSearch = false;
                                    this.showResult = true;
                                    this.$toast.error(this.$t('components.tools.company_identifier.db_something_went_wrong_please_try_again'));
                                }

                                this.csvData.company = this.convertToCSV(this.domainCompanyDetailsSearch);
                                this.csvFields = ["company_number", "company_name", "status", "address", "company_type", "jurisdiction", "incorporation_date"];
                                // this.csvFields = ["name", "registered_address_in_full", "company_number", "company_type", "jurisdiction_code", "updated_at", "current_status", "incorporation_date", "opencorporates_url", "registry_url"];

                                // this.$emit("searched", { data: { companyName: this.searchKeyword }, source: "company" });
                                // this.getdomainCompanyDetailsSearch(this.searchKeyword);
                                // if (this.tabName === "tools") {
                                //     this.SET_ALL_TOOLS_DATA({
                                //         ...this._data,
                                //         "tool-name": "company-name",
                                //     });
                                // } else {
                                //     this.SET_ALL_MONITORING_DATA({
                                //         ...this._data,
                                //         "tool-name": "company-name",
                                //     });
                                // }
                                if (this.dnbCheck) {
                                    await this.dnbLicenseLevel();
                                }
                                this.domainCompanyDetailsSearch.forEach((res)=>{
                                    res.card_status = this.cardDetailsMap[res.api_all_data.doc_id] && this.cardDetailsMap[res.api_all_data.doc_id].status!='None'  ? this.cardDetailsMap[res.api_all_data.doc_id].status : 'UNKNOWN'
                                    res.customer_notes =  this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id].customer_notes : ''
                                    res.research_notes =  this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id].notes : ''
                                    res.risk_categories = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id].risk_categories : []
                                    res.bespoke = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id]?.bespoke : []
                                    res.entity_status = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id]?.entity_status : 'Red'
                                    res.screenshot = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id]?.screenshot : {}
                                })
                                this.cardStatusResults = this.domainCompanyDetailsSearch
                                
                                await this.getAllCardsDetails()
                                this.setCardStatusCounts()
                                
                                this.SET_ALL_TOOLS_DATA({
                                    ...this._data,
                                    "tool-name": "company-name",
                                });
                                this.triggerRoute = true;
                                this.$emit("searchResult", {data: this.domainCompanyDetailsSearch, source: "company", searchType: "name"});
                                if (this.domainCompanyDetailsSearch.length <= 0) {
                                    this.totalResults = 0;
                                } else {
                                    this.domainCompanyDetailsSearch = this.domainCompanyDetailsSearch.map((ele, index) => ({...ele, current_index: index}));
                                    this.totalResults = this.domainCompanyDetailsSearch.length;
                                }
                                this.resetLoader("companySearch");
                                let configMissing = this.checkConfig(values)
                                if (configMissing.length>0) {
                                    configMissing.forEach((mes)=>{
                                        this.$toast.error(mes)
                                    })
                                    return
                                }
                                this.$emit("updateQueryTotal", { checkName: this.$route.query.check_name });
                                await this.afterSearchResponseReceived({ 
                                    searchResults: results 
                                });
                                this.$emit("updateToolData", "company-name");
                            })
                            .catch((error) => {
                                if (error.response && error.response.status === 406) {
                                    const message = error.response?.data?.detail ||  this.$t('general.default_error2');
                                    this.$toast.error(message);
                                }
                                this.showSearch = false;
                                this.showResult = true;
                                this.resetLoader("companySearch");
                            });
                    }
                } else if ((this.officer) || this.queries[i - 1]?.officer) {
                  
                    // if (i === 0) {
                    //     this.jurisdiction = null;
                    // } else this.queries[i - 1].jurisdiction = null;
                    this.$emit("searched", {data: {name: i === 0 ? this.officer : this.queries[i - 1].officer}, source: "company"});
                    await this.getOfficerSearch(this.officer ,refreshFlag);
                    await this.getAllCardsDetails()
                    let sources = [];
                    if (this.openCorporatesCheck) {
                        sources.push("openCorporates");
                    }
                    if (this.bvdCheck) {
                        sources.push("bvd");
                    }
                    if (this.tabName === "tools") {
                        this.SET_ALL_TOOLS_DATA({
                            ...this._data,
                            "tool-name": "company-name",
                        });
                    } else {
                        this.SET_ALL_MONITORING_DATA({
                            ...this._data,
                            "tool-name": "company-name",
                        });
                    }
                    this.resetLoader("companySearch");
                    this.triggerRoute = true;
                } else if ((i === 0 && this.address) || this.queries[i - 1]?.address) {
                    if (i === 0) {
                        this.jurisdiction = null;
                    } else this.queries[i - 1].jurisdiction = null;
                    this.$emit("searched", {data: {companyName: i === 0 ? this.address : this.queries[i - 1].address}, source: "company"});
                    await this.getdomainCompanyAddressSearch(i === 0 ? this.address : this.queries[i - 1].address, i, refreshFlag);
                    await this.getAllCardsDetails()
                    if (this.tabName === "tools") {
                        this.SET_ALL_TOOLS_DATA({
                            ...this._data,
                            "tool-name": "company-name",
                        });
                    } else {
                        this.SET_ALL_MONITORING_DATA({
                            ...this._data,
                            "tool-name": "company-name",
                        });
                    }

                    this.triggerRoute = true;
                } else if ((i === 0 && this.registry.firstName) || this.registry.middleName || this.registry.lastName || this.registry.nickname || this.queries[i - 1]?.firstName || this.queries[i - 1]?.middleName || this.queries[i - 1]?.lastName || this.queries[i - 1]?.nickname) {
                    this.$router.push(this.$route.path);
                    this.showResult = true;
                    this.showSearch = true;
                    this.resetLoader("companySearch");
                } else if (i === 0) {
                    this.$toast.error(this.$t('components.v_is_required', { value: this.fieldType.text }));
                }
            }
            // await this.getAllCardsDetails()
            // this.setCardStatusCounts()
            this.isloadingDetails = false;
            this.isLoading = false;
        },
        // flattenObject(obj, keys = []) {
        //     // ["company_name", "name_en"];
        //     // obj={company_name: {name_en: "Bentata Mohammed", name_ar: "بن طاطة محمد"}}
        //     let key = "";
        //     let flatVal = obj;
        //     keys.forEach((ele) => {
        //         if (typeof flatVal === "object") {
        //             key = ele;
        //         }
        //         flatVal = flatVal[key];
        //     });
        //     return flatVal;
        // },
        bypassCache() {},
        redirectToQuery() {
            if (this.$route?.query?.query_id) {
                this.apiCallPages = 1;
                let {query_id} = this.$route.query;
                let selected_query = this.toolSearchQueries?.find((el) => el._id === query_id);
                const {sources, code, mode} = selected_query?.query;
                let q, type;
                if (selected_query?.query?.name) {
                    q = selected_query?.query?.name;
                    type = "company";
                } else if (selected_query?.query?.officer) {
                    q = selected_query?.query?.officer;
                    type = "officer";
                } else if (selected_query?.query?.address) {
                    q = selected_query?.query?.address;
                    type = "address";
                }
                if (q && type) {
                    switch (type) {
                        case "company":
                            // this.searchKeyword, this.officer, this.address
                            this.officer = "";
                            this.address = "";
                            this.searchKeyword = q;
                            if (code) {
                                this.jurisdiction = this.jurisdictionList[0].categories.find((n) => n.value === code);
                            }
                            if (mode) {
                                let search_mode_find = this.searchMode?.props?.options?.find((ele) => ele.value === mode);
                                this.searchMode.value = search_mode_find;
                            }
                            this.registry.firstName = "";
                            this.registry.middleName = "";
                            this.registry.lastName = "";
                            this.registry.nickname = "";
                            this.selectedItem = {
                                value: q,
                            };
                            this.fieldType = {
                                text: "Company",
                                value: "company",
                            };
                            break;
                        case "officer":
                            this.searchKeyword = "";
                            this.address = "";
                            this.registry.firstName = "";
                            this.registry.middleName = "";
                            this.registry.lastName = "";
                            this.registry.nickname = "";
                            this.officer = q;
                            this.fieldType = {
                                text: "Officer",
                                value: "officer",
                            };
                            if (code) {
                                this.jurisdiction = this.jurisdictionList[0].categories.find((n) => n.value === code);
                            }
                            if (mode) {
                                let search_mode_find = this.searchMode?.props?.options?.find((ele) => ele.value === mode);
                                this.searchMode.value = search_mode_find;
                            }
                            break;
                        case "address":
                            this.searchKeyword = "";
                            this.officer = "";
                            this.registry.firstName = "";
                            this.registry.middleName = "";
                            this.registry.lastName = "";
                            this.registry.nickname = "";
                            this.address = q;
                            this.fieldType = {
                                text: "Address",
                                value: "address",
                            };
                            break;
                        default:
                            break;
                    }
                    this.selectVal = [q];
                    if (sources) {
                        this.openCorporatesCheck = sources.includes("opencorporates");
                        this.clarifiedByCheck = sources.includes("clarifiedby");
                        this.companyWatchCheck = sources.includes("companywatch");
                        this.bvdCheck = sources.includes("bvd");
                        this.dnbCheck = sources.includes("db");
                    }
                    this.order_by = null;
                    this.search(false, false, false);
                } else if (((this.selectedItem && this.searchKeyword) || this.officer || this.address) && this.fieldType.value && this.searchClicked) {
                    if (sources?.length > 0) {
                        this.openCorporatesCheck = sources.includes("opencorporates");
                        this.clarifiedByCheck = sources.includes("clarifiedby");
                        this.companyWatchCheck = sources.includes("companywatch");
                        this.bvdCheck = sources.includes("bvd");
                        this.dnbCheck = sources.includes("db");
                    }
                    this.search(false, false, false);
                }
            } else {
                this.redirectTo();
            }
        },
        redirectTo() {
            let query = this.$route.query;
            if (this.request_id)
                query = {
                    ...query,
                    query_id: this.request_id,
                };

            this.$router.push({path: this.$route.path, query}).catch(() => {});
        },
        clipboardCheck() {
            return this.fieldType.value === "officer";
        },
        getTable(level) {
            let copyData = this.domainCompanyDetailsSearchList.filter((ele) => ele.sourceTag === "openCorporates");
            if (level === "L3") {
                return `<table width="100%" cellpadding="9" cellspacing="2" style=" font-size: 11pt !important; table-layout: fixed; width: 100%;"> <colgroup><col width="78"> <col width="81"> <col width="90"> <col width="62"> <col width="80"> <col width="90"> <col width="22"> </colgroup><thead> <tr> <td width="78" height="7" bgcolor="#0070c0" style="background: #0070c0"><p class="western" align="center" style="font-family: 'Lato', serif !important;color:#ffffff;"> <b style="font-size:11.0pt !important;line-height:120%;font-family:&quot;Lato&quot;,sans-serif !important;">Company</b></p> </td> <td width="81" bgcolor="#0070c0" style="background: #0070c0"><p class="western" align="center" style="font-family: 'Lato', serif !important;color:#ffffff;"> <b style="font-size:11.0pt !important;line-height:120%;font-family:&quot;Lato&quot;,sans-serif !important;">Company Number</b></p> </td> <td width="90" bgcolor="#0070c0" style="background: #0070c0"><p class="western" align="center" style="font-family: 'Lato', serif !important; color:#ffffff;"> <b style="font-size:11.0pt !important;line-height:120%;font-family:&quot;Lato&quot;,sans-serif !important;">Company Status</b></p> </td> <td width="62" bgcolor="#0070c0" style="background: #0070c0"><p class="western" align="center" style="font-family: 'Lato', serif !important;color:#ffffff;"> <b style="font-size:11.0pt !important;line-height:120%;font-family:&quot;Lato&quot;,sans-serif !important;">Role</b></p> </td> <td width="80" bgcolor="#0070c0" style="background: #0070c0"><p class="western" align="center" style="font-family: 'Lato', serif !important;color:#ffffff;"> <b style="font-size:11.0pt !important;line-height:120%;font-family:&quot;Lato&quot;,sans-serif !important;">Date Appointed</b></p> </td> <td width="90" bgcolor="#0070c0" style="background: #0070c0"><p class="western" align="center" style="font-family: 'Lato', serif !important;color:#ffffff;"> <b style="font-size:11.0pt !important;line-height:120%;font-family:&quot;Lato&quot;,sans-serif !important;">Role Status</b></p> </td> <td width="22" bgcolor="#0070c0" style="background: #0070c0"><p class="western" align="center" style="color: white; width: 0.4in; margin: auto; font-family: 'Lato', serif !important; "> <img src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAACAklEQVRIidWVy2pTQRyHv0kDVpRGBS9E8bJzHQVRUOvGtm4sdiHqvq8g+hQ1utEXkK6LBXEhplURYpT0BWxFU1Gpt53g5yITPJ2cpKm7zmrON//b+c/Mb2CrjzCIkXoMOA0cAARWgZchhHf/nVkN6pTaUFvqL3VBXYzzVly7og5UaDZ4SZ1XX6tj6kl1Rd2h7lTfqyfiWkN9pJY2E7ypzqhDkd1Tb2Vsbqt347yoVqNP/ySxLfPqTMKX1Ermu6I2E5uqOrdRgqnYlqHkj36oxQwrRlZK2Bt1sl+ChjqWsFG1lmO7oJ5P2IRaz7JCZvEoUAaeJLH2Aa2celaBvQl7DByMx3p9Atrn/GkI4U/itAv4lpNgDdiTBdG3BpzqsGJmvQwcVm8mgc4CIzn8OFBWdyf8UIzVlQBgG5A6bAeGc/gw8LsH7x7qNfVhDp9W7+fwB+p0Dp9Vr3a+s3vwArigFhKftZwqod3/r0nwAnAOeNWVIISwDHwELiaBPtMWuXTsB74kbBz40FMEo3A1kktVUr8PeNHebnTRQhSuOwlv5kjFUmKTKxXr+h1CELhOey+qmaprQPaGjwPPMpVXgVHgRs/qk2pK6lzUlokozStRqjtyXVEvxbbMqSMDBU8STap19VN8ZBbV5+rPyOrq5X4xBn0yjwBn+HeaWrSfzOVNV73lxl+mLetSj8thHwAAAABJRU5ErkJggg=='/> </p> </td> </tr> </thead> <tbody>
                ${
                    copyData?.length > 0
                        ? copyData
                              .map((elem) => elem.api_all_data.officer)
                              .map(
                                  (ele) => `
                <tr> <td width="78" height="4" bgcolor="#e7e6e6" style="background: #e7e6e6"><p class="western" align="center" style="font-family: 'Lato', serif !important;word-break: break-all;">${ele?.company.name ? startCase(toLower(ele?.company.name)) : "&nbsp;"}</p> </td> <td width="81" bgcolor="#e7e6e6" style="background: #e7e6e6"><p class="western" align="center" style="font-family: 'Lato', serif !important;word-break: break-all;"> ${
                    ele?.company?.company_number ?? "&nbsp;"
                }</p> </td> <td width="90" bgcolor="#e7e6e6" style="background: #e7e6e6"><p class="western" align="center" style="font-family: 'Lato', serif !important;word-break: break-all;"> ${!ele.inactive ? "Active since " : "Dissolved "} <br/>  ${
                    !ele.inactive ? (ele?.start_date ? DateTime.fromISO(ele?.start_date).toFormat("dd MMM yyyy") : "&nbsp;") : ele?.end_date ? DateTime.fromISO(ele?.end_date).toFormat("dd MMM yyyy") : "&nbsp;"
                }</p> </td> <td width="62" bgcolor="#e7e6e6" style="background: #e7e6e6"><p class="western" align="center" style="font-family: 'Lato', serif !important;word-break: break-all;"> ${ele?.position ? startCase(toLower(ele.position)) : "&nbsp;"}</p> </td> <td width="80" bgcolor="#e7e6e6" style="background: #e7e6e6"><p class="western" align="center" style="font-family: 'Lato', serif !important;word-break: break-all;"> ${
                    ele?.start_date ? DateTime.fromISO(ele?.start_date).toFormat("dd MMM yyyy") : "&nbsp;"
                }</p> </td> <td width="90" bgcolor="#e7e6e6" style="background: #e7e6e6"><p class="western" align="center" style="font-family: 'Lato', serif !important;word-break: break-all;"> ${!ele.inactive ? "Active " : "Dissolution "}</p> </td> <td width="22" bgcolor="#e7e6e6" style="background: #e7e6e6"><p class="western" align="center" style="font-family: 'Lato', serif !important;word-break: break-all;"> ${ele?.jurisdiction_code ?? "&nbsp;"}</p> </td> </tr>
                `
                              )
                              .join("")
                        : `<tr> <td colspan="5" width="78" height="4" bgcolor="#e7e6e6" style="background: #e7e6e6"><p class="western" align="center" style="font-family: 'Lato', serif !important;">No information identified</p> </td></tr>`
                }
                 </tbody> </table>`;
            } else {
                return `<table width="100%" cellpadding="9" cellspacing="2" style=" font-size: 11pt !important; table-layout: fixed; width: 100%; "> <colgroup><col width="184"> <col width="213"> <col width="171"> </colgroup> <thead> <tr> <td colspan="3" width="597" height="21" bgcolor="#0070c0" style="background: #0070c0"><p class="western" align="center" style="font-family:'Lato',serif !important;color:#ffffff;"> <b style="font-size:11.0pt !important;line-height:120%;font-family:&quot;Lato&quot;,sans-serif !important;">Directorships & Company Records</b></p> </td> </tr> <tr> <td width="184" height="28" bgcolor="#0070c0" style="background: #0070c0"><p class="western" align="center" style="font-family:'Lato',serif !important;color:#ffffff;"> <b style="font-size:11.0pt !important;line-height:120%;font-family:&quot;Lato&quot;,sans-serif !important;">Company</b></p> </td> <td width="213" bgcolor="#0070c0" style="background: #0070c0"><p class="western" align="center" style="font-family:'Lato',serif !important;color:#ffffff;"> <b style="font-size:11.0pt !important;line-height:120%;font-family:&quot;Lato&quot;,sans-serif !important;">Role</b></p> </td> <td width="171" bgcolor="#0070c0" style="background: #0070c0"><p style="font-family:'Lato',serif !important;color:#ffffff;" class="western" align="center"> <b style="font-size:11.0pt !important;line-height:120%;font-family:&quot;Lato&quot;,sans-serif !important;">Dates of Appointment</b></p> </td> </tr> </thead>
                <tbody>
                ${
                    copyData?.length > 0
                        ? copyData
                              .map((elem) => elem.api_all_data.officer)
                              .map(
                                  (ele) =>
                                      `<tr> <td width="184" height="21" bgcolor="#E7E6E6" style="background: #E7E6E6"><p class="western" align="center" style="font-family:'Lato',serif !important;word-break: break-all;">${ele?.company?.name ? startCase(toLower(ele?.company?.name)) : "&nbsp;"}</p> </td> <td width="213" bgcolor="#E7E6E6" style="background: #E7E6E6"><p class="western" align="center" style="font-family:'Lato',serif !important;word-break: break-all;">${
                                          ele.position ? startCase(toLower(ele.position)) : "&nbsp;"
                                      }</p> </td> <td width="171" bgcolor="#E7E6E6" style="background: #E7E6E6"><p class="western" align="center" style="font-family:'Lato',serif !important;word-break: break-all;"> ${ele?.start_date ? DateTime.fromISO(ele.start_date).toFormat("MMM yyyy") : "&nbsp;"} - ${ele?.start_date ? (ele?.end_date ? DateTime.fromISO(ele?.end_date).toFormat("MMM yyyy") : "Present") : ""} </p> </td> </tr> `
                              )
                              .join("")
                        : `<tr> <td colspan="3" width="78" height="4" bgcolor="#e7e6e6" style="background: #e7e6e6"><p class="western" align="center" style="font-family: 'Lato', serif !important;word-break: break-all;">No information identified</p> </td></tr>`
                }
                </tbody>
                </table>`;
            }
        },
        async handleCopyToClipboard() {
            let level = "L1";
            // isEmpty
            let product = "";
            if (isEmpty(this.getCasePersonalData)) {
                let {data} = await blackAxios.get(`case-personal-data/${this.case_id}`);
                product = data.case_data?.data["Due Diligence Level"]?.value ?? "";
            }
            product = product ? product : this.getCasePersonalData?.data["Due Diligence Level"]?.value ?? "";
            if (product) {
                const {data} = await blackAxios.get("/product-mapper", {
                    params: {
                        product,
                    },
                });
                if (data?.data?.product_type) level = data?.data?.product_type;
            }
            let table_template = this.getTable(level);
            const el = document.createElement("div");
            el.innerHTML = table_template;
            el.setAttribute("id", "table-template");
            el.style.position = "absolute";
            el.style.left = "-9999px";
            document.body.appendChild(el);
            let social_media = document.getElementById("table-template");
            let range, sel;
            if (document.createRange && window.getSelection) {
                range = document.createRange();
                sel = window.getSelection();
                sel.removeAllRanges();
                try {
                    range.selectNodeContents(social_media);
                    sel.addRange(range);
                } catch (e) {
                    range.selectNode(social_media);
                    sel.addRange(range);
                }
                document.execCommand("copy");
            } 
            this.$toast.success(this.$t('components.tools.company_identifier.copied_to_clipboard'));
        },
        // handleSourceChange(e) {
        // },
        backToSearch() {
            if (this.getSelectedEntity?.entity_type == 'Company') {
                let preFilledValue = this.prebuiltQueryPayload?.name
                    || this.getSelectedEntity?.entity_name
                this.selectedItem = {
                    text: "Company",
                    value: preFilledValue
                }  
                
                this.fieldType = {
                    text: "Company",
                    value:"company"
                }
                this.officer = null
                this.searchKeyword = preFilledValue
            } else if  (this.getSelectedEntity?.entity_type == 'Person') {
                this.fieldType = {
                    text: "Officer",
                    value:"officer"
                }
                this.officer = this.prebuiltQueryPayload?.name
                    || this.getSelectedEntity?.entity_full_name
                this.searchKeyword = null
            }
            this.showMoreInfo = false;
            this.showSearch = true;
            this.selectedCard = null;
            this.isOldVersionSelected = false;
            this.timeline = [];
            this.isAllRunQueries = false;
            this.$emit("updateMonitoringCascadingTimeline", {
                timeline: this.timeline,
                meta_data: null,
            });
            this.request_id = "";
            this.showResult = false;
            this.monitoringActive = false;
            this.redirectTo();
        },
        handleCloseMoreInfo() {
            this.showMoreInfo = false;
            this.selectedCard = null;
            this.isOldVersionSelected = false;
        },
        async handlePageChange(page_number) {
            this.handleCloseMoreInfo();
            document.getElementById("corpor_rec").scrollTo({
                top: "0px",
                behavior: "smooth",
            });
            this.page_number = page_number;
            if (this.isAllRunQueries && 
                (this.page_number + 1) * this.items_count >= this.domainCompanyDetailsSearch?.length && 
                this.domainCompanyDetailsSearch.length < this.totalRecordsInAllQueries) {
                    let sort = {
                        sort_by: this.order_by?.value || "",
                        sort_order: this.order_by?.value ? "desc" : ""
                    }
                    this.isNextPag = true;
                    await this.onRunAllQueries(null, "domainCompanyDetailsSearch", sort);
            }
        },
        addEntity() {
            this.newEntity = {
                type: this.queries.length ? this.queries[this.queries.length - 1].type : this.fieldType,
                company: "",
                officer: "",
                address: "",
                registry: {
                    firstName: "",
                    middleName: "",
                    lastName: "",
                    nickname: "",
                },
                jurisdiction: null,
            };
            this.queries.push(this.newEntity);
            this.entityCount += 1;
            this.newEntity = null;
            this.selectVal.push("");
        },

        removeEntity(i) {
            if (i < 0) {
                if (this.queries?.length) {
                    switch (this.queries[0].type.value) {
                        case "company":
                            this.fieldType = {
                                text: "Company",
                                value: "company",
                            };
                            this.selectedItem = this.queries[0].company;
                            this.searchKeyword = this.selectedItem.value;
                            break;
                        case "officer":
                            this.fieldType = {
                                text: "Officer",
                                value: "officer",
                            };
                            this.officer = this.queries[0].officer;
                            this.searchKeyword = "";
                            break;
                        case "address":
                            this.fieldType = {
                                text: "Address",
                                value: "address",
                            };
                            this.address = this.queries[0].address;
                            this.searchKeyword = "";
                            break;
                        case "registry":
                            this.fieldType = {
                                text: "Registry Search",
                                value: "registry",
                            };
                            this.registry = this.queries[0].registry;
                            this.searchKeyword = "";
                            break;
                        default:
                            this.fieldType = {
                                text: "Company",
                                value: "company",
                            };
                            this.selectedItem = this.queries[0].company;
                            this.searchKeyword = this.selectedItem.value;
                            break;
                    }
                    this.queries.splice(0, 1);
                    this.entityCount -= 1;
                    this.newEntity = null;
                    this.selectVal.splice(0, 1);
                } else {
                    this.selectedItem = null;
                    this.searchKeyword = "";
                    this.selectVal[0] = "";
                }
            } else {
                this.selectVal.splice(i + 1, 1);
                this.queries.splice(i, 1);
                this.entityCount -= 1;
                this.newEntity = null;
            }
        },
        onSelect({value}, idx) {
            this.selectVal[idx - 1] = value;
            this.$refs["analysis-tool-input"][idx - 1].search = value;
        },
        close(idx) {
            if (idx === 1) {
                this.searchKeyword = this.selectVal[0];
                this.selectedItem = {
                    value: this.selectVal[0],
                };
                this.$refs["analysis-tool-input"][0].search = this.selectVal[0];
            } else {
                if (!this.queries[idx - 2].company) {
                    this.queries[idx - 2].company = {value: this.selectVal[idx - 1]};
                } else {
                    this.queries[idx - 2].company.value = this.selectVal[idx - 1];
                }
                this.$refs["analysis-tool-input"][idx - 1].search = this.selectVal[idx - 1];
            }
        },
        handleChange(event, idx) {
            this.selectVal[idx - 1] = event;
        },
        async handleExpandAllPanel(data) {
       
            let company = data.details;
            const key = data.key;
            const isValue = data.value || null;

            let panels = {
                openCorporates: [{type: "mainDetailsCorp"}, {type: "detailsCorp"}, {type: "ownershipCorp"}, {type: "graphCorp"}, {type: "officersCorp"}, {type: "filingCorp"}, {type: "alternativeandPreviousNames"}],
                clarifiedBy: [
                    {api_call_type: "detail", fetched: "fetchedSummary", type: "summary"},
                    {api_call_type: "ownership", fetched: "fetchedOwnership", type: "ownership"},
                    {api_call_type: "management", fetched: "fetchedManagement", type: "management"},
                    {api_call_type: "holdings", fetched: "fetchedHoldings", type: "holdings"},
                    {api_call_type: "activities", fetched: "fetchedActivities", type: "activities"},
                ],
                companyWatch: [{type: "summary"}, {type: "detail"}, {type: "addresses"}, {type: "ccj"}, {type: "accounts"}, {type: "financial"}, {type: "directors"}, {type: "shareholders"}, {type: "events"}, {type: "scores"}],
                bvd: [{type: "CompanyProfile"}, {type: "Contact"}, {type: "InformationProvider"}, {type: "Shareholders"}, {type: "Beneficiaries"}, {type: "Owners"}, {type: "Subsidiaries"}, {type: "directors"}],
                officer_companyWatch: [
                    {api_call_type: "CurrentAppointments", fetched: "fetchedCurrentAppointments", type: "CurrentAppointments"},
                    {api_call_type: "PreviousAppointments", fetched: "fetchedPreviousAppointments", type: "PreviousAppointments"},
                ],
                // officer_bvd: [
                //     // { type: "detailsCorp" }
                // ],
            };

            panels.address = panels.openCorporates;
            panels.officer = panels.openCorporates;
            panels.officer_clarifiedBy = panels.clarifiedBy;
            panels.officer_bvd = panels.bvd;
            if (isValue === true) {
                company.expandedPanel = true;
            } else {
                company.expandedPanel = !company.expandedPanel;
            }
            // const waitForMs = ms => new Promise(res => setTimeout(res, ms))

            for (const ele of panels[key]) {
                if (ele.api_call_type && ele.fetched) {
                    if (!company[ele.fetched]) {
                        await this.showMoreData({...company, api_call_type: ele.api_call_type});
                        // await waitForMs(1050); // wait for api calls
                    }
                    company[`${ele.type}Expanded`] = false;
                }
                company = {...company, [`${ele.type}Expanded`]: company.expandedPanel}
                company = cloneDeep(company)
               
            }
            let detailsExpanded = true;
            if (company.detailsExpanded === false) detailsExpanded = false;

            if (detailsExpanded) {
                this.companyDetails = {...this.companyDetails, ...company};
            }

            this.$forceUpdate();
           
            if (this.isComparisonModeOn) this.updateComparisonReferences({...company, handleExpandAllFlag: false});
        },

        async handleMarkAsAllDone(event) {
            const visited = event.target.checked;
            const payload = {
                case_id: this.getNeoCaseId,
                entity_id: this.$route.query.entityId,
                query_id: !this.isAllRunQueries ? this.getSelectedToolQuery.query_id: undefined,
                tool_name: this.$route.query.check_name || this.autorun?.headers['x-tool-name'],
                visited: visited,
                status: this.tabsStatus.selected && this.tabsStatus.selected !== 'all' ? 
                    (
                        this.tabsStatus.selected.toUpperCase() !== 'UNKNOWN' ? 
                            this.tabsStatus.selected.toUpperCase() : 
                            ""
                    ) : 
                    undefined
            };
            
            try {
                const response = await getMarkAllAsDone(payload);
                if (response.success) {
                    // Update UI state for all results
                    this.domainCompanyDetailsSearchList.forEach(result => {
                        result.api_all_data.changes_viewed = visited;
                    });
                    
                    if (this.timeline.length > 0) {
                        this.timeline = this.timeline.map(res => {
                            let obj = res;
                            obj.api_all_data.changes_viewed = visited;
                            return obj;
                        });
                    }
                    this.$emit('getQueriesMonitoring');
                    this.$emit("updateQueryTotal", { checkName: this.$route.query.check_name })
                }
            } catch (error) {
                console.error("Error marking all as done:", error);
            }
        },

        /**
         * @function
         * @name toggleAllSources - toggle selection of all sources
         */
        toggleAllSources() {
            if (!this.allSourcesChecked) {
                this.openCorporatesCheck = true;
                this.clarifiedByCheck = true;
                this.companyWatchCheck = true;
                this.bvdCheck = true;
                this.dnbCheck = true;
            } else {
                this.openCorporatesCheck = false;
                this.clarifiedByCheck = false;
                this.companyWatchCheck = false;
                this.bvdCheck = false;
                this.dnbCheck = false;
            }
        },

        async handleSavedCard(cardData) {
            this.isSavedLoading = {
                loading: true,
                loadingCardIndex: cardData.api_all_data.doc_id,
            };
            let source = cardData.sourceTag?.toLowerCase() ?? cardData.key?.toLowerCase();
            source = source === "address" ? "opencorporates" : source;
            let body = {
                sources: [source],
                doc_id: cardData.api_all_data.doc_id,
                saved: !cardData.api_all_data.saved,
                card_data: {
                    created_at: null,
                    updated_at: null,
                    case_id: this.case_id,
                    query_id: this.request_id,
                    tool: "tool-corporate-meta",
                    tool_name: this.$route.params.toolName,
                },
            };
            try {
                const {data} = await blackAxios.post(`osint-tools/card/mark-as-saved`, body);
                if (data && data.success) {
                    let allResults = cloneDeep(this.domainCompanyDetailsSearch);
                    let cardIndex = allResults.findIndex((res) => res.api_all_data.doc_id === cardData.api_all_data.doc_id);
                    let cardResult = allResults[cardIndex];
                    cardResult.api_all_data.saved = !cardResult.api_all_data.saved;
                    allResults.splice(cardIndex, 1, cardResult);
                    this.domainCompanyDetailsSearch = allResults;
                    if (this.companyDetails.api_all_data.doc_id === cardData.api_all_data.doc_id) {
                        this.companyDetails.api_all_data.saved = !this.companyDetails.api_all_data.saved;
                    }
                    // this.$toast.success(!cardData.api_all_data.saved ? 'Saved!' : 'Updated!' )
                    this.$toast.success(this.$t('components.tools.company_identifier.updated'));
                    this.$emit("refreshQueries");
                    this.$forceUpdate();
                }
                this.isSavedLoading = {
                    loading: false,
                    loadingCardIndex: null,
                };
            } catch (error) {
                this.isSavedLoading = {
                    loading: false,
                    loadingCardIndex: null,
                };
            }
        },

        getFormattedTime(ts) {
            if (ts) {
                let date = new Date(ts).toISOString();
                date = DateTime.fromISO(date);
                return date.toFormat("dd MMM yyyy");
            }
            return "-";
        },

        async handleSearch() {
            if (
                (this.officer || this.selectedItem) && this.bvdCheck &&
                  this.BVDDateOfBirth?.drops[0]?.value||
                this.BVDDateOfBirth?.drops[1]?.value ||
                this.BVDDateOfBirth?.drops[2]?.value
              ) {
                if (!this.BVDDateOfBirth?.drops[0]?.value) {
                  this.$toast.error(this.$t('components.tools.company_identifier.please_provide_the_dob'));
                  return;
                }
                if (!this.BVDDateOfBirth?.drops[1]?.value) {
                  this.$toast.error(this.$t('components.tools.company_identifier.please_provide_the_dob'));
                  return;
                }
                if (!this.BVDDateOfBirth?.drops[2]?.value) {
                  this.$toast.error(this.$t('components.tools.company_identifier.please_provide_the_dob'));
                  return;
                }
              }
            try {
                this.setQueryResultLoader(true);
                this.page_number = 1;
                let globalFilters = false;
                globalFilters = await this.checkGlobalFilters();
                if (!globalFilters) {
                    await this.manualSearch();
                    await this.getToolsStatus()
                }  
            } catch(e){
                console.error(e)
            } finally{
                this.setQueryResultLoader(false)
            }
        },

        async checkGlobalFilters() {
            if (this.nerFilters) {
                try {
                    const confirm = await this.$refs["modal-confirm"].show({
                        title: this.$t('components.tools.company_identifier.reset_global_filters_title'),
                        message: this.$t('components.tools.company_identifier.reset_global_filters_message'),
                        autoclose: false,
                    });
                    if (confirm) {
                        this.$emit("handleNerClear");
                        this.$refs["modal-confirm"].close();
                        return false;
                    } else return true;
                } catch (error) {
                    this.$refs["modal-confirm"].close();
                }
            } else return false;
        },

        async showMonitoringHistory(data) {
            // TODO check this condition when WLP 5.0 is ready
            if (this.autorun) return;

            let payload = data.payload;
            payload.case_id = this.getNeoCaseId
            let source = [];
            if (this.sources?.length > 0) {
                source = this.sources;
            }
            // delete payload.monitoringHistoryIndex;
            if (payload.monitoringHistoryIndex) {
                this.timeline = [];
                const values = await monitoringHistoryData(payload, source, this.$route.query.check_name);
                if (values?.length > 0) {
                    let open_corporates,
                        clarifiedBy,
                        companyWatch,
                        bvd = [];
                    if (this.fieldType.value === "company") {
                        open_corporates = this.getMappingValue(
                            values.filter((val) => val.doc_source === "opencorporates"),
                            "openCorporates",
                            CORPORATE_TOOL_MAPPING
                        );
                        clarifiedBy = this.getMappingValue(
                            values.filter((val) => val.doc_source === "clarifiedby"),
                            "clarifiedBy",
                            CORPORATE_TOOL_MAPPING
                        );
                        companyWatch = this.getMappingValue(
                            values.filter((val) => val.doc_source === "companywatch"),
                            "companyWatch",
                            CORPORATE_TOOL_MAPPING
                        );
                        bvd = this.getMappingValue(
                            values.filter((val) => val.doc_source === "bvd"),
                            "bvd",
                            CORPORATE_TOOL_MAPPING
                        );
                    } else {
                        open_corporates = this.getMappingValue(
                            values.filter((val) => val.doc_source === "opencorporates"),
                            "officer",
                            CORPORATE_TOOL_MAPPING,
                            "openCorporates"
                        );
                        clarifiedBy = this.getMappingValue(
                            values.filter((val) => val.doc_source === "clarifiedby"),
                            "officer_clarifiedBy",
                            CORPORATE_TOOL_MAPPING,
                            "clarifiedBy"
                        );
                        companyWatch = this.getMappingValue(
                            values.filter((val) => val.doc_source === "companywatch"),
                            "officer_companyWatch",
                            CORPORATE_TOOL_MAPPING,
                            "companyWatch"
                        );
                        let results = [];

                        values
                            .filter((val) => val.doc_source === "bvd")
                            .forEach((officer) => {
                                let start = results.length;
                                results.push(officer);
                                for (let i = start; i < results.length; i++)
                                    results[i] = {
                                        ...results[i],
                                        officerName: officer.CONTACTS_HEADER_FULLNAME,
                                        directorId: officer.CONTACTS_HEADER_IdDirector,
                                        country: officer.CONTACTS_HEADER_HomeCountry,
                                        doc_source: officer.doc_source,
                                        monitoring_id: officer.monitoring_id,
                                        monitoring_result_status: officer.monitoring_result_status,
                                        changes_viewed: officer.changes_viewed,
                                        // monitoring_status: officer.monitoring_status,
                                        monitoringDate: officer.monitoringDate,
                                        // monitoring_result_flag: officer.
                                        // mon_src._source.data.monitoring_result_status = mon_src._source.status;
                                        // mon_src._source.data.monitoring_status = mon_src.monitoring_status;
                                    };
                            });
                        // results = uniqBy(
                        //     results.map((item) => ({
                        //         ...item,
                        //         key: "officer_bvd",
                        //     })),
                        //     "CONTACTS_MEMBERSHIP_IdCompany"
                        // );
                        bvd = this.getMappingValue(results, "officer_bvd", CORPORATE_TOOL_MAPPING, "bvd");
                    }
                    this.timeline = [...this.timeline, ...open_corporates, ...clarifiedBy, ...bvd, ...companyWatch];
                    this.timeline = this.timeline.map((ele, index) => ({...ele, current_index: index, isOldVersion: true}));
                    this.timeline.forEach((res)=> {
                        res.card_status = this.cardDetailsMap[res.api_all_data.doc_id] && this.cardDetailsMap[res.api_all_data.doc_id].status!='None'  ? this.cardDetailsMap[res.api_all_data.doc_id].status : 'UNKNOWN'
                        res.customer_notes =  this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id].customer_notes : ''
                        res.research_notes =  this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id].notes : ''
                        res.risk_categories = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id].risk_categories : []
                        res.bespoke = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id]?.bespoke : []
                        res.entity_status = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id]?.entity_status : 'Red'
                        res.screenshot = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id]?.screenshot : {}
                    })
                }
                const parent = {
                    ...data.detail,
                    is_parent: true,
                };
                const meta_data = {
                    searchedQueryKeyword: this.searchedQueryKeyword,
                    fieldType: this.fieldType,
                    selectedQuery: this.selectedQuery,
                };
                this.updateMonitoringCascadingTimeline({
                    timeline: cloneDeep(this.timeline)
                        .reverse()
                        .concat([parent]),
                    meta_data: meta_data,
                });
                this.setCardStatusCounts()
            } else {
                this.timeline = [];
                this.updateMonitoringCascadingTimeline({
                    timeline: this.timeline,
                    meta_data: null,
                });
                this.setCardStatusCounts()
            }
        },

        updateComparisonReferences(details) {
            if (this.isComparisonModeOn) {
                const isOldVersion = details.isOldVersion;
                if (isOldVersion) {
                    this.updateMonitoringCascadingTimeline({
                        newData: details,
                    });
                } else {
                    const parent = {
                        ...details,
                        is_parent: true,
                    };
                     this.updateMonitoringCascadingTimeline({
                        newData: parent,
                    });
                }
            }
        },

        handleCorporateRecordsConfirmation(event) {
            this.$emit("recordsConfirmation", event);
        },
    },
};
